
        console.log('🚀 MonVillage - Initialisation multi-pays bilingue');

        // Initialize country and language from saved preferences
        initCountry();
        initLang();
        document.body.setAttribute('data-country', currentCountry);

        const cc = () => getCountryConfig();

        // CONFIGURATION AVEC VARIABLES D'ENVIRONNEMENT
        const CONFIG = {
            supabase: {
                url: import.meta.env?.VITE_SUPABASE_URL || 'https://hrlufnjhwhgddxkpyzst.supabase.co',
                anonKey: import.meta.env?.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhybHVmbmpod2hnZGR4a3B5enN0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTI3MzIwMzcsImV4cCI6MjA2ODMwODAzN30.0gMYonFDAU84i3boEIKZDK4OQhDrAXXJySGDa80wTZ8'
            },
            mapbox: {
                accessToken: import.meta.env?.VITE_MAPBOX_ACCESS_TOKEN || 'pk.eyJ1IjoiZWthbnNvbiIsImEiOiJjbWUyeDFxZDUwMTVrMmlvcHMzaDlwOXRvIn0.r7nOAUE0YU8c4miQFeJZWg'
            },
            flutterwave: {
                publicKey: import.meta.env?.VITE_FLUTTERWAVE_PUBLIC_KEY || 'FLWPUBK-de06efbef44902ddb3aa4a1680436c38-X'
            },
            get map() { return cc().map; },
            print: {
                formats: {
                    A4: { price: 500, width: 210, height: 297 },
                    A3: { price: 1000, width: 297, height: 420 },
                    A2: { price: 2000, width: 420, height: 594 },
                    A1: { price: 4000, width: 594, height: 841 },
                    A0: { price: 6000, width: 841, height: 1189 }
                }
            }
        };

        let map, supabase, previewMap;
        let mapLayers = { regions: null, departements: null, arrondissements: null, villages: null, villagesPonctuels: null, poi: null, geonames: null };
        let mapDataCache = { regions: [], departements: [], arrondissements: [], villages: [], villagesPonctuels: [] };
        let baseLayers = { standard: null, satellite: null };
        let currentBaseLayer = 'standard';
        let suspended = false;

        // Geo-pricing: detect user continent for pricing multiplier
        let userGeoInfo = { continent: null, country: null, isAfrica: true, hasActiveSubscription: false };
        const AFRICA_COUNTRIES = ['DZ','AO','BJ','BW','BF','BI','CV','CM','CF','TD','KM','CD','CG','CI','DJ','EG','GQ','ER','SZ','ET','GA','GM','GH','GN','GW','KE','LS','LR','LY','MG','MW','ML','MR','MU','MA','MZ','NA','NE','NG','RW','ST','SN','SC','SL','SO','ZA','SS','SD','TZ','TG','TN','UG','ZM','ZW'];
        const PRICE_MULTIPLIER_OUTSIDE_AFRICA = 3;

        function isOutsideAfrica() {
            return userGeoInfo.continent !== null && !userGeoInfo.isAfrica;
        }

        function getEffectivePrice(basePrice) {
            if (userGeoInfo.hasActiveSubscription) return 0;
            return isOutsideAfrica() ? basePrice * PRICE_MULTIPLIER_OUTSIDE_AFRICA : basePrice;
        }

        async function checkActiveSubscription(email) {
            if (!supabase || !email) return false;
            try {
                const { data, error } = await supabase
                    .from('subscriptions')
                    .select('id, expires_at')
                    .eq('email', email)
                    .eq('status', 'active')
                    .gte('expires_at', new Date().toISOString())
                    .limit(1);
                if (!error && data && data.length > 0) {
                    userGeoInfo.hasActiveSubscription = true;
                    return true;
                }
            } catch (e) {
                console.log('Subscription check failed:', e);
            }
            return false;
        }

        async function detectUserLocation() {
            try {
                const resp = await fetch('https://ipapi.co/json/', { signal: AbortSignal.timeout(5000) });
                const data = await resp.json();
                userGeoInfo.continent = data.continent_code || null;
                userGeoInfo.country = data.country_code || null;
                userGeoInfo.isAfrica = AFRICA_COUNTRIES.includes(data.country_code);
                console.log('Geo-pricing:', userGeoInfo);

                // Auto-switch country if user hasn't manually chosen one
                if (!localStorage.getItem('monvillage_country')) {
                    const countryMap = { UG: 'ug', CM: 'cm' };
                    const detected = countryMap[data.country_code];
                    if (detected && detected !== currentCountry) {
                        switchCountry(detected);
                    }
                }

                if (isOutsideAfrica()) {
                    refreshPriceDisplay();
                    scheduleSubscriptionPrompt();
                }
            } catch (e) {
                console.log('Geo detection failed, defaulting to Africa pricing');
            }
        }
        let isPrintSelectorOn = false;
        let previewRect = null;

        let measurementLayer;
        let isDistanceMeasuring = false;
        let isAreaMeasuring = false;
        let distanceMarkers = [];
        let measurementLines = [];
        let measurementPolygons = [];
        let polygonPoints = [];
        let tempPolygon = null;

        let printBounds = null;
        let isSelectingPrintArea = false;
        let selectedPaymentMethod = 'mobilemoney';

        // Variables pour l'impression
        let printConfig = {
            title: 'Carte des Villages - MonVillage',
            format: 'A2',
            scale: 50000,
            outputFormat: 'pdf',
            showNorthArrow: true,
            showScale: true,
            showLegend: true,
            showCoordinates: true,
            price: 2000,
            bounds: null
        };

        // Variables pour la géolocalisation
        let userLocationMarker = null;
        let userLocationAccuracy = null;
        let isLocating = false;

        // Variables pour la recherche intelligente
        let searchTimeout;
        let currentSearchResults = [];
        let searchSelectedIndex = -1;


        function buildLayerOrder() {
            const levels = cc().adminLevels.slice().reverse();
            const order = [{ name: 'villages', layer: mapLayers.villages, minZoom: 0 }];
            levels.forEach(lv => {
                order.push({ name: lv.key, layer: mapLayers[lv.key], minZoom: lv.minZoom || 0 });
            });
            return order;
        }

        function applyClickHierarchy() {
            const layerOrder = buildLayerOrder();

            // Supprimer les handlers de clic individuels sur toutes les couches
            layerOrder.forEach(config => {
                if (config.layer) {
                    config.layer.eachLayer(layer => {
                        layer.off('click');
                        if (layer.eachLayer) {
                            layer.eachLayer(sub => sub.off('click'));
                        }
                    });
                }
            });

            // Un seul handler global sur la carte pour gérer la priorité
            map.off('click', handleHierarchyClick);
            map.on('click', handleHierarchyClick);
        }

        function handleHierarchyClick(e) {
            // Ne pas interférer avec les outils de mesure ou la sélection d'impression
            if (isDistanceMeasuring || isAreaMeasuring || isPrintSelectorOn) return;

            const latlng = e.latlng;
            const zoom = map.getZoom();

            const layerOrder = buildLayerOrder();

            for (const config of layerOrder) {
                if (zoom < config.minZoom) continue;
                if (!config.layer || !map.hasLayer(config.layer)) continue;

                let found = false;
                config.layer.eachLayer(group => {
                    if (found) return;
                    const layers = group.getLayers ? group.getLayers() : [group];
                    layers.forEach(sub => {
                        if (found) return;
                        if (sub.getBounds && sub.getBounds().contains(latlng)) {
                            let inside = false;
                            if (sub.getLatLngs) {
                                inside = isPointInLayer(latlng, sub);
                            } else {
                                inside = true;
                            }
                            if (inside && (sub.getPopup() || group.getPopup())) {
                                map.closePopup();
                                const target = sub.getPopup() ? sub : group;
                                setTimeout(() => target.openPopup(latlng), 10);
                                found = true;
                            }
                        }
                    });
                });
                if (found) return;
            }
        }

        function isPointInLayer(latlng, layer) {
            const latlngs = layer.getLatLngs();
            if (!latlngs || latlngs.length === 0) return false;
            // Gère les multi-polygones (tableau imbriqué)
            const rings = Array.isArray(latlngs[0][0]) ? latlngs.flat() : latlngs;
            for (const ring of rings) {
                if (isPointInPolygon(latlng, Array.isArray(ring[0]) ? ring[0] : ring)) return true;
            }
            return false;
        }

        function isPointInPolygon(point, polygon) {
            let inside = false;
            const x = point.lat, y = point.lng;
            for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
                const xi = polygon[i].lat, yi = polygon[i].lng;
                const xj = polygon[j].lat, yj = polygon[j].lng;
                const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
                if (intersect) inside = !inside;
            }
            return inside;
        }





        

        // FONCTIONS UTILITAIRES
        function parseGeometry(geom) {
            if (!geom) return null;
            try {
                return typeof geom === 'object' ? geom : JSON.parse(geom);
            } catch (error) {
                console.error('Erreur parsing géométrie:', error);
                return null;
            }
        }

        function showNotification(message, type = 'info', duration = 4000) {
            const notification = document.getElementById('notification');
            notification.textContent = message;
            notification.className = `notification ${type} show`;
            
            setTimeout(() => {
                notification.classList.remove('show');
            }, duration);
        }

            function createCustomPanes() {
                console.log('🎨 Création des panes personnalisés');
                
                const panes = [
                    { name: 'regionsPane', zIndex: 400 },
                    { name: 'departementsPane', zIndex: 410 },
                    { name: 'arrondissementsPane', zIndex: 650 },
                    { name: 'villagesPane', zIndex: 660 },
                    { name: 'villagesPonctuelsPane', zIndex: 655 }
                ];
                
                panes.forEach(pane => {
                    if (!map.getPane(pane.name)) {
                        const customPane = map.createPane(pane.name);
                        customPane.style.zIndex = pane.zIndex;
                        customPane.style.pointerEvents = 'auto';
                        console.log(`✅ ${pane.name} (z-index: ${pane.zIndex})`);
                    }
                });
            }


        function calculateDistance(latlng1, latlng2) {
            const R = 6371000;
            const lat1 = latlng1.lat * Math.PI / 180;
            const lat2 = latlng2.lat * Math.PI / 180;
            const deltaLat = (latlng2.lat - latlng1.lat) * Math.PI / 180;
            const deltaLng = (latlng2.lng - latlng1.lng) * Math.PI / 180;

            const a = Math.sin(deltaLat/2) * Math.sin(deltaLat/2) +
                    Math.cos(lat1) * Math.cos(lat2) *
                    Math.sin(deltaLng/2) * Math.sin(deltaLng/2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));

            return R * c;
        }

        function calculatePolygonArea(latlngs) {
            if (latlngs.length < 3) return 0;
            
            const R = 6371000;
            let area = 0;
            const n = latlngs.length;
            
            for (let i = 0; i < n; i++) {
                const j = (i + 1) % n;
                const lat1 = latlngs[i].lat * Math.PI / 180;
                const lat2 = latlngs[j].lat * Math.PI / 180;
                const deltaLng = (latlngs[j].lng - latlngs[i].lng) * Math.PI / 180;
                
                area += deltaLng * (2 + Math.sin(lat1) + Math.sin(lat2));
            }
            
            area = Math.abs(area) * R * R / 2;
            return area;
        }

        function calculateAreaFromGeometry(geometry) {
            if (!geometry || !geometry.coordinates) {
                return t('village.not_calculated');
            }
            
            try {
                let coordinates;
                if (geometry.type === 'Polygon') {
                    coordinates = geometry.coordinates[0];
                } else if (geometry.type === 'MultiPolygon') {
                    let totalArea = 0;
                    geometry.coordinates.forEach(polygon => {
                        const polygonCoords = polygon[0].map(coord => ({lat: coord[1], lng: coord[0]}));
                        totalArea += calculatePolygonArea(polygonCoords);
                    });
                    return totalArea;
                }
                
                if (coordinates && coordinates.length > 3) {
                    const latlngs = coordinates.map(coord => ({lat: coord[1], lng: coord[0]}));
                    const area = calculatePolygonArea(latlngs);
                    return area;
                }
                
                return 0;
            } catch (error) {
                console.error('Erreur calcul superficie:', error);
                return t('village.not_calculated');
            }
        }

        function formatDistance(distance) {
            if (distance < 1000) {
                return `${Math.round(distance)} m`;
            } else {
                return `${(distance / 1000).toFixed(2)} km`;
            }
        }

        function formatArea(area) {
            if (area < 1000) {
                return `${Math.round(area)} m²`;
            } else if (area < 10000) {
                return `${(area / 1000).toFixed(2)} k m²`;
            } else if (area < 1000000) {
                const hectares = area / 10000;
                return `${hectares.toFixed(2)} ha`;
            } else {
                const km2 = area / 1000000;
                if (km2 < 10) {
                    return `${km2.toFixed(3)} km²`;
                } else if (km2 < 1000) {
                    return `${km2.toFixed(2)} km²`;
                } else {
                    return `${Math.round(km2).toLocaleString()} km²`;
                }
            }
        }

        


        function initializePreviewMap() {
            // Handled by initPreviewMap() now
            initPreviewMap();
        }


        // ================================================================
        // FONCTIONS DE RECHERCHE INTELLIGENTE
        // ================================================================

        function initializeIntelligentSearch() {
            const searchInput = document.getElementById('searchInput');
            const searchResults = document.getElementById('searchResults');
            
            // Événement de saisie avec debounce
            searchInput.addEventListener('input', function(e) {
                clearTimeout(searchTimeout);
                const query = e.target.value.trim();
                
                if (query.length < 2) {
                    hideSearchResults();
                    return;
                }
                
                searchTimeout = setTimeout(() => {
                    performIntelligentSearch(query);
                }, 300);
            });
            
            // Événement de focus
            searchInput.addEventListener('focus', function() {
                if (currentSearchResults.length > 0) {
                    showSearchResults();
                }
            });
            
            searchInput.addEventListener('keydown', function(e) {
                const items = document.querySelectorAll('.search-result-item');
                if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    searchSelectedIndex = Math.min(searchSelectedIndex + 1, items.length - 1);
                    updateSearchSelection(items);
                } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    searchSelectedIndex = Math.max(searchSelectedIndex - 1, 0);
                    updateSearchSelection(items);
                } else if (e.key === 'Enter') {
                    e.preventDefault();
                    const idx = searchSelectedIndex >= 0 ? searchSelectedIndex : 0;
                    if (currentSearchResults.length > 0) selectSearchResult(currentSearchResults[idx]);
                } else if (e.key === 'Escape') {
                    hideSearchResults();
                    searchSelectedIndex = -1;
                }
            });
            
            // Cacher les résultats quand on clique ailleurs
            document.addEventListener('click', function(e) {
                if (!searchInput.contains(e.target) && !searchResults.contains(e.target)) {
                    hideSearchResults();
                }
            });
        }

        function removeAccents(str) {
            return str.normalize('NFD').replace(/[̀-ͯ]/g, '');
        }

        function normalizeSearch(str) {
            return removeAccents(str.toLowerCase()).replace(/[''`'ʼʻ‘’\-\s]/g, '');
        }

        function searchScore(nameNorm, arrNorm, queryNorm) {
            if (nameNorm === queryNorm) return 100;
            if (nameNorm.startsWith(queryNorm)) return 80;
            if (nameNorm.includes(queryNorm)) return 60;
            if (arrNorm && arrNorm.includes(queryNorm)) return 30;
            const words = queryNorm.split(/\s+/);
            if (words.length > 1 && words.every(w => nameNorm.includes(w) || (arrNorm && arrNorm.includes(w)))) return 40;
            if (queryNorm.length >= 3 && fuzzyMatch(nameNorm, queryNorm)) return 20;
            return 0;
        }

        function fuzzyMatch(text, query) {
            let ti = 0, qi = 0, gaps = 0, lastMatch = -1;
            while (ti < text.length && qi < query.length) {
                if (text[ti] === query[qi]) {
                    if (lastMatch >= 0 && ti - lastMatch > 1) gaps++;
                    lastMatch = ti;
                    qi++;
                }
                ti++;
            }
            return qi === query.length && gaps <= Math.floor(query.length / 3);
        }

        let vpAllData = null;
        let vpAllDataPromise = null;
        let vpSearchCache = null;


        async function loadAllVpData() {
            if (vpAllData) return vpAllData;
            if (vpAllDataPromise) return vpAllDataPromise;
            vpAllDataPromise = (async () => {
                const PAGE = 1000;
                const config = cc();
                const vpTable = config.vpTable;
                const isUg = currentCountry === 'ug';
                const selectCols = isUg
                    ? 'id,name,district_name,population,type,geom'
                    : 'id,name,arrondissement_name,population,geom';
                const ugTypes = ['village', 'city', 'town', 'national_capital'];

                function buildQuery(from, to) {
                    let q = supabase.from(vpTable).select(selectCols);
                    if (isUg) q = q.in('type', ugTypes);
                    return q.range(from, to);
                }

                let all = [];
                let offset = 0;
                let done = false;
                while (!done) {
                    const PARALLEL = 6;
                    const promises = [];
                    for (let i = 0; i < PARALLEL; i++) {
                        promises.push(buildQuery(offset + i * PAGE, offset + (i + 1) * PAGE - 1));
                    }
                    const results = await Promise.all(promises);
                    for (const res of results) {
                        if (res.error || !res.data || res.data.length === 0) { done = true; break; }
                        all = all.concat(res.data);
                        if (res.data.length < PAGE) { done = true; break; }
                    }
                    offset += PARALLEL * PAGE;
                }
                vpAllData = all;
                console.log(`Loaded ${vpAllData.length} VP from ${vpTable}`);
                return vpAllData;
            })();
            return vpAllDataPromise;
        }

        async function getVpSearchCache() {
            if (vpSearchCache) return vpSearchCache;
            const all = await loadAllVpData();
            const parentCol = cc().vpParentCol;
            vpSearchCache = all.map(vp => {
                let lat = null, lng = null;
                const g = parseGeometry(vp.geom);
                if (g) {
                    if (g.type === 'MultiPoint') { lng = g.coordinates[0][0]; lat = g.coordinates[0][1]; }
                    else if (g.type === 'Point') { lng = g.coordinates[0]; lat = g.coordinates[1]; }
                }
                const parentName = vp[parentCol] || vp.arrondissement_name || vp.district_name || '';
                return {
                    id: vp.id,
                    name: vp.name,
                    arrondissement_name: vp.arrondissement_name,
                    district_name: vp.district_name,
                    type: vp.type,
                    population: vp.population,
                    lat, lng,
                    _nameNorm: vp.name ? normalizeSearch(vp.name) : '',
                    _arrNorm: parentName ? normalizeSearch(parentName) : ''
                };
            });
            console.log(`Search cache: ${vpSearchCache.length} VP`);
            return vpSearchCache;
        }

        async function performIntelligentSearch(query) {
            if (!supabase) {
                showNotification(t('notif.offline_search'), 'warning');
                return;
            }

            try {
                const queryNorm = normalizeSearch(query);
                const config = cc();
                const nameCol = config.villageNameCol || 'name';

                const queryClean = removeAccents(query);

                let polygonQueries;
                if (currentCountry === 'cm') {
                    polygonQueries = [
                        supabase.from(config.villageSearchTable).select('*')
                            .or(`village_name.ilike.%${query}%,chief_name.ilike.%${query}%`)
                            .eq('is_active', true).limit(8),
                        supabase.from(config.villageSearchTable).select('*')
                            .or(`village_name.ilike.%${queryClean}%,chief_name.ilike.%${queryClean}%`)
                            .limit(10)
                    ];
                } else {
                    polygonQueries = [
                        supabase.from(config.villageSearchTable).select('*')
                            .ilike('name', `%${query}%`)
                            .eq('is_active', true).limit(8),
                        supabase.from(config.villageSearchTable).select('*')
                            .ilike('name', `%${queryClean}%`)
                            .limit(10)
                    ];
                }

                const [polygonRes1, polygonRes2, vpCache] = await Promise.all([
                    ...polygonQueries,
                    getVpSearchCache()
                ]);

                const seen = new Set();
                const polygonResults = [];
                for (const res of [polygonRes1, polygonRes2]) {
                    if (res.error || !res.data) continue;
                    for (const v of res.data) {
                        const key = v.id || (v.village_name || v.name);
                        if (!seen.has(key)) {
                            seen.add(key);
                            polygonResults.push({ ...v, _type: 'polygon' });
                        }
                    }
                }

                const scored = vpCache
                    .map(vp => ({ vp, score: searchScore(vp._nameNorm, vp._arrNorm, queryNorm) }))
                    .filter(s => s.score > 0)
                    .sort((a, b) => b.score - a.score)
                    .slice(0, 10)
                    .map(s => ({ ...s.vp, _type: 'ponctuel' }));

                currentSearchResults = [...polygonResults, ...scored].slice(0, 12);
                displaySearchResults(currentSearchResults, query);

            } catch (error) {
                console.error('Search error:', error);
                showNotification(t('notif.search_error'), 'error');
            }
        }

        function displaySearchResults(results, query) {
            const searchResults = document.getElementById('searchResults');

            if (!results || results.length === 0) {
                searchResults.innerHTML = `<div class="search-result-item">${t('search.no_results')}</div>`;
                searchResults.style.display = 'block';
                return;
            }

            const resultsHTML = results.map((item, index) => {
                if (item._type === 'ponctuel') {
                    const vpName = highlightMatch(item.name || t('popup.no_name'), query);
                    const parentName = item[cc().vpParentCol] || item.arrondissement_name || item.district_name || '';
                    const badge = item.type || t('search.badge_ponctuel');
                    return `
                        <div class="search-result-item" data-index="${index}">
                            <div class="search-result-main">
                                <strong>${vpName}</strong>
                                <span class="search-result-badge" style="background:#e74c3c;color:#fff;">${badge}</span>
                            </div>
                            <div class="search-result-details">
                                <div class="search-result-location">
                                    <i class="fas fa-map-pin"></i> ${parentName || t('popup.vp_type')}
                                </div>
                            </div>
                        </div>
                    `;
                }
                const villageName = highlightMatch(item.village_name || item.name || '', query);
                const chiefLine = cc().hasChefferie ? `
                            <div class="search-result-chief">
                                <i class="fas fa-user-tie"></i> ${item.chief_name ? highlightMatch(item.chief_name, query) : t('village.not_provided')}
                            </div>` : '';
                const locationParts = currentCountry === 'cm'
                    ? [item.arrondissement_name, item.departement_name, item.region_name].filter(Boolean).join(' → ')
                    : [item.district_name, item.region_name].filter(Boolean).join(' → ');
                return `
                    <div class="search-result-item" data-index="${index}">
                        <div class="search-result-main">
                            <strong>${villageName}</strong>
                            <span class="search-result-badge">${t('search.badge_village')}</span>
                        </div>
                        <div class="search-result-details">
                            ${chiefLine}
                            <div class="search-result-location">
                                <i class="fas fa-map-marker-alt"></i>
                                ${locationParts}
                            </div>
                        </div>
                    </div>
                `;
            }).join('');

            searchResults.innerHTML = resultsHTML;
            searchResults.style.display = 'block';

            searchSelectedIndex = -1;
            document.querySelectorAll('.search-result-item').forEach(el => {
                el.addEventListener('click', function() {
                    const idx = parseInt(this.getAttribute('data-index'));
                    selectSearchResult(results[idx]);
                });
            });
        }

        function updateSearchSelection(items) {
            items.forEach((el, i) => el.classList.toggle('selected', i === searchSelectedIndex));
            if (items[searchSelectedIndex]) items[searchSelectedIndex].scrollIntoView({ block: 'nearest' });
        }

        function highlightMatch(text, query) {
            if (!text) return '';
            const textNorm = normalizeSearch(text);
            const queryNorm = normalizeSearch(query);
            const normIdx = textNorm.indexOf(queryNorm);
            if (normIdx === -1) return text;
            let ni = 0, startOrig = 0, endOrig = text.length;
            for (let i = 0; i < text.length; i++) {
                if (ni === normIdx) { startOrig = i; break; }
                if (normalizeSearch(text[i])) ni++;
            }
            ni = 0;
            let matchedChars = 0;
            for (let i = startOrig; i < text.length; i++) {
                if (normalizeSearch(text[i])) matchedChars++;
                if (matchedChars === queryNorm.length) { endOrig = i + 1; break; }
            }
            return text.slice(0, startOrig) + '<mark>' + text.slice(startOrig, endOrig) + '</mark>' + text.slice(endOrig);
        }

        function hideSearchResults() {
            const searchResults = document.getElementById('searchResults');
            if (searchResults) {
                searchResults.style.display = 'none';
                searchResults.style.top = '';
            }
        }

        function showSearchResults() {
            const searchResults = document.getElementById('searchResults');
            if (searchResults && currentSearchResults.length > 0) {
                searchResults.style.display = 'block';
                if (window.innerWidth <= 480) {
                    const rect = document.querySelector('.search-container').getBoundingClientRect();
                    searchResults.style.top = rect.bottom + 'px';
                }
            }
        }

        function selectSearchResult(village) {
            if (!village) return;

            hideSearchResults();

            if (village._type === 'ponctuel') {
                document.getElementById('searchInput').value = village.name || t('popup.vp_type');
                const lat = village.lat;
                const lng = village.lng;
                if (!lat || !lng) return;

                const isMobile = window.innerWidth <= 480;
                if (isMobile) {
                    const headerH = document.querySelector('.header').offsetHeight;
                    const offsetY = headerH / 2;
                    map.setView([lat, lng], 15, { animate: true });
                    setTimeout(() => map.panBy([0, -offsetY], { animate: true }), 100);
                } else {
                    map.setView([lat, lng], 15);
                }

                const tryOpenPopup = (attempts) => {
                    const parentName = village[cc().vpParentCol] || village.arrondissement_name || village.district_name || t('village.not_determined');
                    if (!mapLayers.villagesPonctuels || attempts <= 0) {
                        L.popup()
                            .setLatLng([lat, lng])
                            .setContent(createVillagePonctuelPopup(village, parentName))
                            .openOn(map);
                        return;
                    }
                    if (!map.hasLayer(mapLayers.villagesPonctuels)) map.addLayer(mapLayers.villagesPonctuels);
                    let found = false;
                    mapLayers.villagesPonctuels.eachLayer(marker => {
                        if (!found && marker.vpData && marker.vpData.id === village.id) {
                            marker.openPopup();
                            found = true;
                        }
                    });
                    if (!found && attempts > 1) setTimeout(() => tryOpenPopup(attempts - 1), 500);
                    else if (!found) {
                        L.popup()
                            .setLatLng([lat, lng])
                            .setContent(createVillagePonctuelPopup(village, parentName))
                            .openOn(map);
                    }
                };
                setTimeout(() => tryOpenPopup(5), 300);

                showNotification(t('notif.village_found', {name: village.name || 'ponctuel'}), 'success');
                return;
            }

            document.getElementById('searchInput').value = village.village_name || village.name || '';

            if (village.centroid) {
                const centroid = parseGeometry(village.centroid);
                if (centroid && centroid.coordinates) {
                    const isMobile2 = window.innerWidth <= 480;
                    map.setView([centroid.coordinates[1], centroid.coordinates[0]], 15);
                    if (isMobile2) {
                        const headerH2 = document.querySelector('.header').offsetHeight;
                        setTimeout(() => map.panBy([0, -headerH2 / 2], { animate: true }), 100);
                    }

                    setTimeout(() => {
                        if (mapLayers.villages) {
                            mapLayers.villages.eachLayer(layer => {
                                if (layer.villageData && layer.villageData.id === village.id) {
                                    layer.openPopup();
                                }
                            });
                        }
                    }, 500);
                }
            }
            
            showNotification(t('notif.village_found', {name: village.village_name || village.name || ''}), 'success');
        }

        // ================================================================
        // SYSTEME D'IMPRESSION - SELECTION DE ZONE
        // ================================================================

        function togglePrintSelector() {
            isPrintSelectorOn = !isPrintSelectorOn;
            const btn = document.getElementById('selectPrintArea');
            btn.classList.toggle('active', isPrintSelectorOn);
            btn.innerHTML = isPrintSelectorOn
                ? `<i class="fas fa-stop"></i> ${t('print.stop_selection')}`
                : `<i class="fas fa-vector-square"></i> ${t('print.select_zone')}`;

            if (isPrintSelectorOn) {
                // Minimize the modal
                const modal = document.getElementById('printModal');
                modal.classList.remove('active');
                modal.classList.add('minimized');
                // Show validate button
                let valBtn = document.getElementById('validateZoneBtn');
                if (!valBtn) {
                    valBtn = document.createElement('button');
                    valBtn.id = 'validateZoneBtn';
                    valBtn.textContent = t('print.validate_zone');
                    valBtn.addEventListener('click', function() {
                        // Re-open modal fully
                        const m = document.getElementById('printModal');
                        m.classList.remove('minimized');
                        m.classList.add('active');
                        valBtn.classList.remove('visible');
                        isPrintSelectorOn = false;
                        const b = document.getElementById('selectPrintArea');
                        b.innerHTML = `<i class="fas fa-vector-square"></i> ${t('print.select_zone')}`;
                        b.classList.remove('active');
                        updatePreviewFromBounds();
                        updatePrintAreaSummary();
                        calculateAndDisplayScale();
                    });
                    document.body.appendChild(valBtn);
                }
                valBtn.classList.add('visible');
                createDraggableRectangle();
                showNotification(t('notif.print_zone_activated'), 'info');
            } else {
                removeRectangle();
                let valBtn = document.getElementById('validateZoneBtn');
                if (valBtn) valBtn.classList.remove('visible');
            }
        }

        let printOverlayEl = null;
        let _poAction = null;
        let _poStartX = 0, _poStartY = 0;
        let _poStartRect = null;

        function createDraggableRectangle() {
            removeRectangle();

            const b = map.getBounds();
            const w = b.getWest(), e = b.getEast(), s = b.getSouth(), n = b.getNorth();
            const w2 = w + (e - w) * 0.25, e2 = e - (e - w) * 0.25;
            const s2 = s + (n - s) * 0.25, n2 = n - (n - s) * 0.25;
            printBounds = L.latLngBounds([s2, w2], [n2, e2]);

            printOverlayEl = document.createElement('div');
            printOverlayEl.className = 'print-overlay';
            printOverlayEl.innerHTML =
                '<div class="ph corner nw" data-action="nw"></div>' +
                '<div class="ph corner ne" data-action="ne"></div>' +
                '<div class="ph corner sw" data-action="sw"></div>' +
                '<div class="ph corner se" data-action="se"></div>' +
                '<div class="ph edge n" data-action="n"></div>' +
                '<div class="ph edge s" data-action="s"></div>' +
                '<div class="ph edge w" data-action="w"></div>' +
                '<div class="ph edge e" data-action="e"></div>';

            map.getContainer().appendChild(printOverlayEl);
            syncOverlayPosition();

            printOverlayEl.addEventListener('mousedown', onOverlayPointerDown);
            printOverlayEl.addEventListener('touchstart', onOverlayPointerDown, { passive: false });
            map.on('move zoom moveend zoomend', syncOverlayPosition);

            updatePrintAreaSummary();
        }

        function syncOverlayPosition() {
            if (!printOverlayEl || !printBounds) return;
            const nw = map.latLngToContainerPoint(printBounds.getNorthWest());
            const se = map.latLngToContainerPoint(printBounds.getSouthEast());
            printOverlayEl.style.left = nw.x + 'px';
            printOverlayEl.style.top = nw.y + 'px';
            printOverlayEl.style.width = (se.x - nw.x) + 'px';
            printOverlayEl.style.height = (se.y - nw.y) + 'px';
        }

        function onOverlayPointerDown(evt) {
            var handle = evt.target.closest('[data-action]');
            _poAction = handle ? handle.dataset.action : 'move';

            var clientX, clientY;
            if (evt.touches) {
                if (evt.touches.length !== 1) return;
                clientX = evt.touches[0].clientX;
                clientY = evt.touches[0].clientY;
            } else {
                clientX = evt.clientX;
                clientY = evt.clientY;
            }

            evt.stopPropagation();
            evt.preventDefault();

            _poStartX = clientX;
            _poStartY = clientY;
            _poStartRect = {
                left: parseInt(printOverlayEl.style.left),
                top: parseInt(printOverlayEl.style.top),
                width: parseInt(printOverlayEl.style.width),
                height: parseInt(printOverlayEl.style.height)
            };

            map.dragging.disable();

            document.addEventListener('mousemove', onOverlayPointerMove);
            document.addEventListener('mouseup', onOverlayPointerEnd);
            document.addEventListener('touchmove', onOverlayPointerMove, { passive: false });
            document.addEventListener('touchend', onOverlayPointerEnd);
        }

        function onOverlayPointerMove(evt) {
            if (!_poAction || !_poStartRect) return;
            evt.preventDefault();

            var clientX, clientY;
            if (evt.touches) {
                clientX = evt.touches[0].clientX;
                clientY = evt.touches[0].clientY;
            } else {
                clientX = evt.clientX;
                clientY = evt.clientY;
            }

            var dx = clientX - _poStartX;
            var dy = clientY - _poStartY;
            var r = _poStartRect;
            var nl = r.left, nt = r.top, nw = r.width, nh = r.height;
            var minSize = 30;

            switch(_poAction) {
                case 'move':
                    nl = r.left + dx;
                    nt = r.top + dy;
                    break;
                case 'nw':
                    nl = r.left + dx; nt = r.top + dy;
                    nw = r.width - dx; nh = r.height - dy;
                    break;
                case 'ne':
                    nt = r.top + dy;
                    nw = r.width + dx; nh = r.height - dy;
                    break;
                case 'sw':
                    nl = r.left + dx;
                    nw = r.width - dx; nh = r.height + dy;
                    break;
                case 'se':
                    nw = r.width + dx; nh = r.height + dy;
                    break;
                case 'n':
                    nt = r.top + dy; nh = r.height - dy;
                    break;
                case 's':
                    nh = r.height + dy;
                    break;
                case 'w':
                    nl = r.left + dx; nw = r.width - dx;
                    break;
                case 'e':
                    nw = r.width + dx;
                    break;
            }

            if (nw < minSize) { nw = minSize; if (_poAction.includes('w')) nl = r.left + r.width - minSize; }
            if (nh < minSize) { nh = minSize; if (_poAction.includes('n')) nt = r.top + r.height - minSize; }

            printOverlayEl.style.left = nl + 'px';
            printOverlayEl.style.top = nt + 'px';
            printOverlayEl.style.width = nw + 'px';
            printOverlayEl.style.height = nh + 'px';

            var nwLatLng = map.containerPointToLatLng(L.point(nl, nt));
            var seLatLng = map.containerPointToLatLng(L.point(nl + nw, nt + nh));
            printBounds = L.latLngBounds(
                [seLatLng.lat, nwLatLng.lng],
                [nwLatLng.lat, seLatLng.lng]
            );
            updatePrintAreaSummary();
        }

        function onOverlayPointerEnd() {
            _poAction = null;
            _poStartRect = null;
            map.dragging.enable();
            document.removeEventListener('mousemove', onOverlayPointerMove);
            document.removeEventListener('mouseup', onOverlayPointerEnd);
            document.removeEventListener('touchmove', onOverlayPointerMove);
            document.removeEventListener('touchend', onOverlayPointerEnd);
        }

        function updatePreviewFromBounds() {
            if (!previewMap) initPreviewMap();
            if (!printBounds || !previewMap) return;
            previewMap.fitBounds(printBounds, { animate: false });
            clearPreviewRect();
            previewRect = L.rectangle(printBounds, {
                color: '#ff0000', weight: 2, fillOpacity: 0.05, dashArray: '5 5'
            }).addTo(previewMap);
        }

        function clearPreviewRect() {
            if (previewRect && previewMap) {
                previewMap.removeLayer(previewRect);
                previewRect = null;
            }
        }

        function updateRectFromMap() {
            if (!printOverlayEl) return;
            syncOverlayPosition();
        }

        function removeRectangle() {
            if (printOverlayEl) {
                printOverlayEl.removeEventListener('mousedown', onOverlayPointerDown);
                printOverlayEl.removeEventListener('touchstart', onOverlayPointerDown);
                printOverlayEl.remove();
                printOverlayEl = null;
            }
            map.off('move zoom moveend zoomend', syncOverlayPosition);
            printBounds = null;
            clearPreviewRect();
            const el = document.getElementById('summaryArea');
            if (el) el.textContent = t('print.no_selection');
        }

        function initPreviewMap() {
            if (previewMap) return;
            const el = document.getElementById('previewMap');
            if (!el) return;
            previewMap = L.map(el, {
                center: CONFIG.map.center,
                zoom: CONFIG.map.zoom - 1,
                zoomControl: true,
                attributionControl: false,
                dragging: true,
                touchZoom: true,
                doubleClickZoom: true,
                scrollWheelZoom: true,
                boxZoom: false,
                keyboard: false
            });
            L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                attribution: '&copy; OpenStreetMap',
                maxZoom: 19
            }).addTo(previewMap);
        }

        function useCurrentMapView() {
            const b = map.getBounds();
            printBounds = b;
            if (printOverlayEl) {
                syncOverlayPosition();
            } else {
                createDraggableRectangle();
                printBounds = b;
                syncOverlayPosition();
            }
            updatePreviewFromBounds();
            updatePrintAreaSummary();
            calculateAndDisplayScale();
            showNotification(t('notif.current_view_selected'), 'success');
        }

        function clearPrintAreaSelection() {
            removeRectangle();
            if (isPrintSelectorOn) {
                isPrintSelectorOn = false;
                const btn = document.getElementById('selectPrintArea');
                btn.innerHTML = `<i class="fas fa-vector-square"></i> ${t('print.select_zone')}`;
                btn.classList.remove('active');
                let valBtn = document.getElementById('validateZoneBtn');
                if (valBtn) valBtn.classList.remove('visible');
            }
            const scaleEl = document.getElementById('summaryScale');
            if (scaleEl) scaleEl.textContent = '--';
            showNotification(t('notif.selection_cleared'), 'info');
        }

        function updatePreviewWithBounds(bounds) {
            if (!previewMap || !bounds) return;
            try {
                previewMap.fitBounds(bounds);
                clearPreviewRect();
                previewRect = L.rectangle(bounds, {
                    color: '#ff0000',
                    weight: 2,
                    fillOpacity: 0.05,
                    dashArray: '5, 5'
                }).addTo(previewMap);
            } catch (error) {
                console.error('Erreur mise a jour apercu:', error);
            }
        }

        function updatePrintAreaSummary() {
            const summaryAreaEl = document.getElementById('summaryArea');
            if (!summaryAreaEl) return;
            if (!printBounds) {
                summaryAreaEl.textContent = t('print.no_selection');
                return;
            }
            const ne = printBounds.getNorthEast();
            const sw = printBounds.getSouthWest();
            // Calculate approximate area in km
            const widthKm = haversineDistance(
                sw.lat, sw.lng, sw.lat, ne.lng
            ) / 1000;
            const heightKm = haversineDistance(
                sw.lat, sw.lng, ne.lat, sw.lng
            ) / 1000;
            summaryAreaEl.textContent = `${widthKm.toFixed(1)} km x ${heightKm.toFixed(1)} km`;
        }

        // Haversine distance in meters
        function haversineDistance(lat1, lon1, lat2, lon2) {
            const R = 6371000;
            const dLat = (lat2 - lat1) * Math.PI / 180;
            const dLon = (lon2 - lon1) * Math.PI / 180;
            const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                      Math.sin(dLon/2) * Math.sin(dLon/2);
            const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
            return R * c;
        }

        function calculateAndDisplayScale() {
            if (!printBounds) return;
            const scaleEl = document.getElementById('summaryScale');
            if (!scaleEl) return;

            const sw = printBounds.getSouthWest();
            const ne = printBounds.getNorthEast();
            const centerLat = (sw.lat + ne.lat) / 2;
            const geoWidthM = haversineDistance(centerLat, sw.lng, centerLat, ne.lng);
            const geoHeightM = haversineDistance(sw.lat, sw.lng, ne.lat, sw.lng);

            const userScaleInput = document.getElementById('userScale');
            const userScale = userScaleInput ? parseInt(userScaleInput.value) : 0;

            if (userScale > 0) {
                // User imposed a scale → calculate required paper size
                const requiredWidthM = geoWidthM / userScale;
                const requiredHeightM = geoHeightM / userScale;

                if (requiredWidthM > 2 || requiredHeightM > 2) {
                    scaleEl.textContent = `1:${userScale.toLocaleString()} (${t('print.format_too_large')})`;
                    showNotification(t('notif.scale_too_large', {width: requiredWidthM.toFixed(2), height: requiredHeightM.toFixed(2)}), 'warning', 8000);
                    printConfig.scale = userScale;
                    return;
                }

                // Auto-select custom format with calculated dimensions
                printConfig.format = 'custom';
                printConfig.scale = userScale;

                // Update custom size fields
                const wField = document.getElementById('customWidth');
                const hField = document.getElementById('customHeight');
                if (wField) wField.value = Math.max(1, requiredWidthM).toFixed(2);
                if (hField) hField.value = Math.max(1, requiredHeightM).toFixed(2);

                // Show custom size group
                const customGroup = document.getElementById('customSizeGroup');
                if (customGroup) customGroup.style.display = 'block';

                // Select custom format option visually
                document.querySelectorAll('.format-option').forEach(o => o.classList.remove('selected'));
                const customOpt = document.querySelector('[data-format="custom"]');
                if (customOpt) customOpt.classList.add('selected');

                // Calculate price
                const area = Math.max(1, requiredWidthM) * Math.max(1, requiredHeightM);
                printConfig.price = getEffectivePrice(Math.round(area * 10000));
                const priceEl = document.getElementById('summaryPrice');
                if (priceEl) priceEl.textContent = `${printConfig.price.toLocaleString()} ${cc().currency}`;

                scaleEl.textContent = `1:${userScale.toLocaleString()} → ${Math.max(1, requiredWidthM).toFixed(2)}m x ${Math.max(1, requiredHeightM).toFixed(2)}m`;
                const formatEl = document.getElementById('summaryFormat');
                if (formatEl) formatEl.textContent = `${t('print.custom_label')} (${Math.max(1, requiredWidthM).toFixed(2)}m x ${Math.max(1, requiredHeightM).toFixed(2)}m)`;
            } else {
                // Auto-calculate scale from paper size
                const paperWidthM = getPaperWidthMeters();
                if (!paperWidthM) { scaleEl.textContent = '--'; return; }

                const scale = Math.round(geoWidthM / paperWidthM);
                printConfig.scale = scale;

                if (scale < 100) {
                    scaleEl.textContent = `1:${scale} (${t('print.very_detailed')})`;
                } else if (scale > 5000000) {
                    scaleEl.textContent = `1:${scale.toLocaleString()} (${t('print.very_large_zone')})`;
                } else {
                    scaleEl.textContent = '1:' + scale.toLocaleString();
                }
            }
        }

        function getPaperWidthMeters() {
            if (printConfig.format === 'custom') {
                const w = parseFloat(document.getElementById('customWidth').value) || 1;
                return w; // already in meters
            }
            // Standard formats: data-w attribute is in meters
            const selectedOption = document.querySelector('.format-option.selected');
            if (selectedOption) {
                return parseFloat(selectedOption.dataset.w) || 0.42;
            }
            return 0.42; // default A2 width
        }

        // Admin entity selection - uses mapDataCache (raw Supabase data)
        function loadAdminEntities(adminType) {
            const entitySelect = document.getElementById('adminEntity');
            entitySelect.innerHTML = `<option value="">-- ${t('print.choose_entity')} --</option>`;
            entitySelect.style.display = 'block';

            let dataArr = [];
            let nameKey = '';
            const config = cc();

            if (adminType === 'village') {
                dataArr = mapDataCache.villages;
                nameKey = config.villageNameCol;
            } else {
                const level = config.adminLevels.find(lv => lv.key === adminType || lv.key === adminType + 's');
                if (level) {
                    dataArr = mapDataCache[level.key];
                    nameKey = level.nameCol;
                } else {
                    switch(adminType) {
                        case 'region': dataArr = mapDataCache.regions; nameKey = 'nom_region'; break;
                        case 'departement': dataArr = mapDataCache.departements; nameKey = 'nom_departement'; break;
                        case 'arrondissement': dataArr = mapDataCache.arrondissements; nameKey = 'nom_arrondissement'; break;
                        case 'district': dataArr = mapDataCache.districts; nameKey = 'name'; break;
                    }
                }
            }

            if (!dataArr || dataArr.length === 0) {
                showNotification(t('notif.data_not_loaded'), 'warning');
                return;
            }

            // Sort alphabetically
            const sorted = [...dataArr].sort((a, b) => (a[nameKey] || '').localeCompare(b[nameKey] || ''));

            sorted.forEach((item, idx) => {
                const opt = document.createElement('option');
                opt.value = idx;
                opt.textContent = item[nameKey] || t('popup.no_name');
                entitySelect.appendChild(opt);
            });

            // Store sorted data for later retrieval
            entitySelect._sortedData = sorted;
            entitySelect._nameKey = nameKey;
        }

        function selectAdminEntity(index) {
            const entitySelect = document.getElementById('adminEntity');
            const sortedData = entitySelect._sortedData;
            if (!sortedData || index === '' || index === undefined) return;

            const item = sortedData[parseInt(index)];
            if (!item || !item.geom) {
                showNotification(t('notif.no_geometry'), 'warning');
                return;
            }

            // Parse geometry and compute bounds
            const geometry = parseGeometry(item.geom);
            if (!geometry) {
                showNotification(t('notif.invalid_geometry'), 'warning');
                return;
            }

            // Create a temporary GeoJSON layer to get bounds
            const tempLayer = L.geoJSON(geometry);
            const bounds = tempLayer.getBounds();

            if (bounds && bounds.isValid()) {
                printBounds = bounds;
                updatePreviewFromBounds();
                updatePrintAreaSummary();
                calculateAndDisplayScale();
                // Show rectangle on main map
                removeRectangle();
                printBounds = bounds;
                createDraggableRectangle();
                printBounds = bounds;
                syncOverlayPosition();
                map.fitBounds(bounds);
                showNotification(t('notif.entity_zone_selected'), 'success');
            } else {
                showNotification(t('notif.entity_bounds_error'), 'warning');
            }
        }

        function applyScaleToMap(targetMap, bounds, scale) {
            const metersPerPixel = scale / 100;
            const centerLat = bounds.getCenter().lat;
            const zoom = Math.log2(40075016.686 * Math.abs(Math.cos(centerLat * Math.PI / 180)) / (metersPerPixel * 256));
            targetMap.setView(bounds.getCenter(), Math.round(zoom));
        }


        // CHARGEMENT DES DONNÉES VILLAGES AVEC DESCRIPTIONS
        async function loadInitialData() {
                if (!supabase) {
                    showNotification(t('notif.demo_mode'), 'warning');
                    return;
                }
                try {
                    showNotification(t('notif.loading_layers'), 'info');

                    await Promise.all([
                        loadRegionsOptimized(),
                        loadDepartementsOptimized(),
                        loadArrondissementsOptimized(),
                        loadVillagesOptimized(),
                        loadVillagesPonctuels()
                    ]);

                    applyLayerHierarchy();

                    showNotification(t('notif.data_loaded'), 'success', 2000);
                } catch (err) {
                    console.error('❌ Erreur chargement:', err);
                    showNotification(t('notif.load_error'), 'error');
                }
            }


            function applyLayerHierarchy() {
                console.log('📊 Vérification de la hiérarchie des panes');
                
                const panes = [
                    { name: 'regionsPane', expectedZ: 400 },
                    { name: 'departementsPane', expectedZ: 410 },
                    { name: 'arrondissementsPane', expectedZ: 420 },
                    { name: 'villagesPonctuelsPane', expectedZ: 655 },
                    { name: 'villagesPane', expectedZ: 650 }
                ];
                
                panes.forEach(config => {
                    const pane = map.getPane(config.name);
                    if (pane) {
                        const currentZ = pane.style.zIndex;
                        console.log(`✅ ${config.name}: z-index = ${currentZ}`);
                    }
                });
            }


  async function loadVillagesOptimized() {
    try {
        const config = cc();
        const vtable = config.villageTable;
        const selectCols = currentCountry === 'ug'
            ? 'id,name,district_id,district_name,population,geom'
            : 'id,village_name,nom_arrondissement,chief_name,chief_photo_url,chief_start_date,chief_years_of_service,population,telephone,email,area_hectares,geom';

        let query = supabase.from(vtable).select(selectCols);
        if (currentCountry === 'cm') query = query.eq('is_active', true);
        else query = query.eq('is_active', true);

        const { data, error } = await query;

        if (error) throw error;
        if (!data || data.length === 0) return;

        if (currentCountry === 'cm') {
            data.forEach(v => { if (v.nom_arrondissement) v.arrondissement_name = v.nom_arrondissement; });
        }
        mapDataCache.villages = data;
        mapLayers.villages = L.layerGroup();

        data.forEach(village => {
            if (village.geom) {
                const geometry = parseGeometry(village.geom);
                if (!geometry) return;

                const layer = L.geoJSON(geometry, {
                    style: { 
                        fillColor: 'transparent', 
                        color: '#cc6600', 
                        weight: 2,
                        opacity: 0.8,
                        fillOpacity: 0,
                        dashArray: '8, 6'
                    },
                    interactive: true,
                    pane: 'villagesPane'
                }).addTo(mapLayers.villages);

                const popupContent = createVillagePopup(village);
                const popupMaxWidth = window.innerWidth < 480 ? (window.innerWidth - 60) : 320;
                layer.bindPopup(popupContent, {
                    maxWidth: popupMaxWidth,
                    minWidth: 200,
                    className: 'village-popup'
                });

                layer.villageData = village;
            }
        });
        
        map.addLayer(mapLayers.villages);
        console.log(`✅ ${data.length} villages dans villagesPane (z-index: 650 - PRIORITÉ MAX)`);
        
    } catch (error) {
        console.error('Erreur villages:', error);
        throw error;
    }
}

async function loadVillagesPonctuels() {
    try {
        const data = await loadAllVpData();
        if (!data || data.length === 0) return;

        mapDataCache.villagesPonctuels = data;
        mapLayers.villagesPonctuels = L.layerGroup();
        map.addLayer(mapLayers.villagesPonctuels);

        const CHUNK = 500;
        let i = 0;
        const zoom = map.getZoom();
        const showLabels = zoom >= 12;

        function processChunk() {
            const end = Math.min(i + CHUNK, data.length);
            for (; i < end; i++) {
                const vp = data[i];
                if (!vp.geom) continue;
                const geometry = parseGeometry(vp.geom);
                if (!geometry || !geometry.coordinates || geometry.coordinates.length === 0) continue;

                let lat, lng;
                if (geometry.type === 'MultiPoint') {
                    lng = geometry.coordinates[0][0];
                    lat = geometry.coordinates[0][1];
                } else if (geometry.type === 'Point') {
                    lng = geometry.coordinates[0];
                    lat = geometry.coordinates[1];
                } else continue;

                const marker = L.circleMarker([lat, lng], {
                    radius: 1.3,
                    fillColor: '#000000',
                    color: '#000000',
                    weight: 1,
                    opacity: 1,
                    fillOpacity: 1,
                    pane: 'villagesPonctuelsPane'
                }).addTo(mapLayers.villagesPonctuels);

                const parentArea = vp[cc().vpParentCol] || vp.arrondissement_name || vp.district_name || t('village.not_determined');
                marker.bindPopup(createVillagePonctuelPopup(vp, parentArea), {
                    maxWidth: window.innerWidth < 480 ? (window.innerWidth - 60) : 280,
                    minWidth: 180,
                    className: 'village-popup'
                });

                marker.vpData = vp;

                if (showLabels && vp.name) {
                    marker.bindTooltip(vp.name, { permanent: true, direction: 'right', offset: [6, 0], className: 'vp-label' });
                }
            }
            if (i < data.length) {
                requestAnimationFrame(processChunk);
            } else {
                console.log(`${data.length} villages ponctuels chargés`);
            }
        }
        processChunk();
    } catch (error) {
        console.error('Erreur villages ponctuels:', error);
    }
}

function findParentAdminForPoint(lat, lng) {
    const config = cc();
    const levels = config.adminLevels;
    const parentLevel = levels[levels.length - 1];
    if (!parentLevel) return t('village.not_determined');
    const cache = mapDataCache[parentLevel.key];
    if (!cache) return t('village.not_determined');
    const latlng = L.latLng(lat, lng);
    for (const item of cache) {
        if (!item.geom) continue;
        const geometry = parseGeometry(item.geom);
        if (!geometry) continue;
        try {
            const geoLayer = L.geoJSON(geometry);
            let found = false;
            geoLayer.eachLayer(layer => {
                if (found) return;
                if (layer.getBounds && layer.getBounds().contains(latlng)) {
                    if (layer.getLatLngs) {
                        found = isPointInLayer(latlng, layer);
                    } else {
                        found = true;
                    }
                }
            });
            if (found) return item[parentLevel.nameCol];
        } catch (e) { continue; }
    }
    return t('village.not_determined');
}
function findArrondissementForPoint(lat, lng) { return findParentAdminForPoint(lat, lng); }

function createVillagePonctuelPopup(vp, parentArea) {
    const populationText = vp.population ?
        vp.population.toLocaleString() + ' ' + t('popup.inhabitants') : t('village.not_provided');

    const vpType = vp.type ? vp.type : t('popup.vp_type');

    const adminActions = vpAdminUser && vp.id ? `
                <div class="vp-popup-actions">
                    <button class="vp-popup-btn vp-popup-btn-edit" onclick="vpPopupEdit(${vp.id})"><i class="fas fa-edit"></i> ${t('popup.edit')}</button>
                    <button class="vp-popup-btn vp-popup-btn-move" onclick="vpPopupMove(${vp.id})"><i class="fas fa-arrows-alt"></i> ${t('popup.move')}</button>
                    <button class="vp-popup-btn vp-popup-btn-delete" onclick="vpPopupDelete(${vp.id})"><i class="fas fa-trash"></i></button>
                </div>` : '';

    return `
        <div class="village-popup-inner">
            <div class="village-popup-header">
                <h3 class="village-popup-title">
                    <i class="fas fa-map-pin"></i> ${vp.name || t('popup.no_name')}
                </h3>
                <p class="village-popup-location">${parentArea}</p>
            </div>
            <div class="village-popup-body">
                <div class="village-popup-stats">
                    <div class="village-popup-stat">
                        <div class="village-popup-stat-label">${t('popup.population')}</div>
                        <div class="village-popup-stat-value">${populationText}</div>
                    </div>
                    <div class="village-popup-stat">
                        <div class="village-popup-stat-label">${t('popup.type')}</div>
                        <div class="village-popup-stat-value">${vpType}</div>
                    </div>
                </div>${adminActions}
            </div>
        </div>
    `;
}

function createVillagePopup(village) {
            const villageName = village.village_name || village.name || t('popup.no_name');
            const parentName = village.arrondissement_name || village.district_name || '';

            const areaText = village.area_hectares ?
                `${village.area_hectares.toFixed(2)} ha` : t('village.not_calculated');

            const populationText = village.population ?
                village.population.toLocaleString() + ' ' + t('popup.inhabitants') : t('village.not_provided');

            let chiefHtml = '';
            if (cc().hasChefferie) {
                const phoneText = village.telephone || t('village.not_available');
                const chiefPhotoHtml = village.chief_photo_url ?
                    `<img src="${village.chief_photo_url}" alt="${t('popup.chief_photo')}">`
                    : `<div style="width: 50px; height: 50px; border-radius: 50%; background: #e0e0e0; display: flex; align-items: center; justify-content: center; margin-right: 10px; color: #666; flex-shrink: 0;"><i class="fas fa-user"></i></div>`;
                const chiefServiceYears = village.chief_years_of_service ?
                    ` (${village.chief_years_of_service} ${t('popup.years_service')})` : '';

                chiefHtml = `
                    <div class="village-popup-chief">
                        ${chiefPhotoHtml}
                        <div>
                            <div class="village-popup-chief-label">${t('popup.village_chief')}</div>
                            <div class="village-popup-chief-name">${village.chief_name || t('village.not_provided')}${chiefServiceYears}</div>
                        </div>
                    </div>
                    <div class="village-popup-contact">
                        <div class="village-popup-contact-item">
                            <i class="fas fa-phone"></i>
                            <span>${phoneText}</span>
                        </div>
                        ${village.email ? `
                        <div class="village-popup-contact-item">
                            <i class="fas fa-envelope"></i>
                            <span>${village.email}</span>
                        </div>
                        ` : ''}
                    </div>`;
            }

            return `
                <div class="village-popup-inner">
                    <div class="village-popup-header">
                        <h3 class="village-popup-title">
                            <i class="fas fa-home"></i> ${villageName}
                        </h3>
                        <p class="village-popup-location">${parentName}</p>
                    </div>

                    <div class="village-popup-body">
                        ${chiefHtml}
                        <div class="village-popup-stats">
                            <div class="village-popup-stat">
                                <div class="village-popup-stat-label">${t('popup.area')}</div>
                                <div class="village-popup-stat-value">${areaText}</div>
                            </div>
                            <div class="village-popup-stat">
                                <div class="village-popup-stat-label">${t('popup.population')}</div>
                                <div class="village-popup-stat-value">${populationText}</div>
                            </div>
                        </div>

                        <div class="village-popup-action">
                            <button onclick="openVillageDetails('${village.id}')">
                                <i class="fas fa-info-circle"></i> ${t('popup.learn_more')}
                            </button>
                        </div>
                    </div>
                </div>
            `;
        }

        // FONCTIONS DU MODAL VILLAGE
        window.openVillageDetails = function(villageId) {
            map.closePopup();
            
            let villageData = null;
            if (mapLayers.villages) {
                mapLayers.villages.eachLayer(layer => {
                    if (layer.villageData && layer.villageData.id === villageId) {
                        villageData = layer.villageData;
                    }
                });
            }
            
            if (!villageData) {
                showNotification(t('notif.village_details_error'), 'error');
                return;
            }
            
            displayVillageDetails(villageData);
        };

        async function displayVillageDetails(village) {
            const vName = village.village_name || village.name || t('popup.no_name');
            const parentName = village.arrondissement_name || village.district_name || '';
            const locale = getLang() === 'en' ? 'en-GB' : 'fr-FR';

            document.getElementById('villageModalTitle').textContent = vName;
            document.getElementById('villageModalSubtitle').textContent = parentName;

            const chiefRow = document.getElementById('villageChiefName');
            const chiefDateRow = document.getElementById('villageChiefStartDate');
            const phoneRow = document.getElementById('villageTelephone');
            const emailRow = document.getElementById('villageEmail');

            if (cc().hasChefferie) {
                chiefRow.textContent = village.chief_name || t('village.not_specified');
                chiefDateRow.textContent = village.chief_start_date ?
                    new Date(village.chief_start_date).toLocaleDateString(locale) +
                    (village.chief_years_of_service ? ` (${village.chief_years_of_service} ${t('popup.years_service')})` : '') :
                    t('village.not_specified_f');
                phoneRow.textContent = village.telephone || t('village.not_available');
                emailRow.textContent = village.email || t('village.not_available');
                document.querySelectorAll('.cm-only').forEach(el => {
                    if (el.closest('#villageModal')) el.style.display = currentCountry === 'cm' ? '' : 'none';
                });
            } else {
                document.querySelectorAll('.cm-only').forEach(el => {
                    if (el.closest('#villageModal')) el.style.display = 'none';
                });
            }

            document.getElementById('villageArea').textContent = village.area_hectares ?
                `${village.area_hectares.toFixed(2)} ha` : t('village.not_calculated');
            document.getElementById('villagePopulation').textContent = village.population ?
                village.population.toLocaleString() + ' ' + t('popup.inhabitants') : t('village.not_specified_f');

            await displayVillagePhotos(village);
            await loadVillageDescription(village.id);

            const arrInfoEl = document.getElementById('villageArrondissementInfo');
            if (arrInfoEl) arrInfoEl.textContent = parentName;

            let basicInfo = '';
            if (cc().hasChefferie && village.chief_name) {
                basicInfo += `${village.chief_name}. `;
            }
            if (village.area_hectares) {
                basicInfo += `${village.area_hectares.toFixed(2)} ha. `;
            }
            if (village.population) {
                basicInfo += `${t('popup.population')}: ${village.population.toLocaleString()}.`;
            }
            document.getElementById('villageBasicInfo').textContent = basicInfo;

            switchTab('info');
            document.getElementById('villageModal').classList.add('active');
            document.body.style.overflow = 'hidden';
        }

        async function displayVillagePhotos(village) {
            const photosSection = document.getElementById('villagePhotosSection');
            const photosGrid = document.getElementById('villagePhotosGrid');
            
            let photos = [];
            
            // Photo du chef
            if (village.chief_photo_url) {
                photos.push({
                    url: village.chief_photo_url,
                    caption: `${village.chief_name || t('popup.village_chief')}`
                });
            }
            
            if (supabase && currentCountry === 'cm') {
                try {
                    const { data: villagePhotos, error } = await supabase
                        .from('village_photos')
                        .select('*')
                        .eq('village_id', village.id)
                        .order('photo_order');
                    
                    if (!error && villagePhotos) {
                        villagePhotos.forEach((photo, index) => {
                            const vn = village.village_name || village.name || '';
                            photos.push({
                                url: photo.photo_url,
                                caption: `${vn} (${index + 1})`
                            });
                        });
                    }
                } catch (error) {
                    console.error('Erreur chargement photos village:', error);
                }
            }
            
            if (photos.length > 0) {
                photosSection.style.display = 'block';
                photosGrid.innerHTML = photos.map(photo => `
                    <div class="village-photo">
                        <img src="${photo.url}" alt="${photo.caption}" loading="lazy" 
                             onerror="this.style.display='none'">
                        <div class="village-photo-caption">${photo.caption}</div>
                    </div>
                `).join('');
            } else {
                photosSection.style.display = 'none';
            }
        }

        async function loadVillageDescription(villageId) {
            if (!supabase || currentCountry !== 'cm') {
                document.getElementById('descriptionTab').style.display = 'none';
                return;
            }
            
            try {
                const { data: description, error } = await supabase
                    .from('village_descriptions')
                    .select('*')
                    .eq('village_id', villageId)
                    .eq('is_published', true)
                    .single();
                
                if (error || !description) {
                    document.getElementById('descriptionTab').style.display = 'none';
                    return;
                }
                
                const hasContent = checkHasDescriptionContent(description);
                
                if (hasContent) {
                    document.getElementById('descriptionTab').style.display = 'block';
                    populateDescriptionContent(description);
                } else {
                    document.getElementById('descriptionTab').style.display = 'none';
                }
                
            } catch (error) {
                console.error('Erreur chargement description:', error);
                document.getElementById('descriptionTab').style.display = 'none';
            }
        }

        function checkHasDescriptionContent(description) {
            return description.histoire_origine || description.description_limites || 
                   description.importance_region || description.danses_musiques_rites ||
                   description.gastronomie_locale || description.fetes_traditionnelles ||
                   description.structure_demographique || description.groupes_ethniques ||
                   description.activites_generatrices || description.produits_terroir ||
                   description.infrastructures_scolaires || description.infrastructures_sante ||
                   description.infrastructures_routes || description.acces_electricite_eau ||
                   description.sites_naturels || description.sites_culturels ||
                   description.personnalites_originaires;
        }

        function populateDescriptionContent(description) {
            // Cacher le message "pas de description"
            document.getElementById('noDescriptionMessage').style.display = 'none';
            
            // Présentation générale
            populateSection('presentationSection', [
                { id: 'histoireOrigineSec', contentId: 'histoireOrigineContent', data: description.histoire_origine },
                { id: 'limitesSection', contentId: 'limitesContent', data: description.description_limites },
                { id: 'importanceSection', contentId: 'importanceContent', data: description.importance_region }
            ]);
            
            // Culture & Traditions
            populateSection('cultureSection', [
                { id: 'dansesSection', contentId: 'dansesContent', data: description.danses_musiques_rites },
                { id: 'gastronomieSection', contentId: 'gastronomieContent', data: description.gastronomie_locale },
                { id: 'fetesSection', contentId: 'fetesContent', data: description.fetes_traditionnelles }
            ]);
            
            // Population
            populateSection('populationSection', [
                { id: 'demographieSection', contentId: 'demographieContent', data: description.structure_demographique },
                { id: 'ethniesSection', contentId: 'ethniesContent', data: description.groupes_ethniques }
            ]);
            
            // Économie
            populateSection('economieSection', [
                { id: 'activitesSection', contentId: 'activitesContent', data: description.activites_generatrices },
                { id: 'produitsSection', contentId: 'produitsContent', data: description.produits_terroir }
            ]);
            
            // Infrastructures
            populateSection('infrastructuresSection', [
                { id: 'ecolesSection', contentId: 'ecolesContent', data: description.infrastructures_scolaires },
                { id: 'santeSection', contentId: 'santeContent', data: description.infrastructures_sante },
                { id: 'routesSection', contentId: 'routesContent', data: description.infrastructures_routes },
                { id: 'servicesSection', contentId: 'servicesContent', data: description.acces_electricite_eau }
            ]);
            
            // Tourisme
            populateSection('tourismeSection', [
                { id: 'sitesNaturelsSection', contentId: 'sitesNaturelsContent', data: description.sites_naturels },
                { id: 'sitesCulturelsSection', contentId: 'sitesCulturelsContent', data: description.sites_culturels }
            ]);
            
            // Personnalités
            populateSection('personnalitesSection', [
                { id: 'personnalitesOriginairesSection', contentId: 'personnalitesOriginairesContent', data: description.personnalites_originaires }
            ]);
        }

        function populateSection(sectionId, subsections) {
            const section = document.getElementById(sectionId);
            let hasContent = false;
            
            subsections.forEach(subsection => {
                const element = document.getElementById(subsection.id);
                const content = document.getElementById(subsection.contentId);
                
                if (subsection.data && subsection.data.trim()) {
                    element.style.display = 'block';
                    content.textContent = subsection.data.trim();
                    hasContent = true;
                } else {
                    element.style.display = 'none';
                }
            });
            
            section.style.display = hasContent ? 'block' : 'none';
        }

        window.switchTab = function(tabName) {
            // Désactiver tous les onglets
            document.querySelectorAll('.village-tab').forEach(tab => {
                tab.classList.remove('active');
            });
            document.querySelectorAll('.village-tab-content').forEach(content => {
                content.classList.remove('active');
            });
            
            // Activer l'onglet sélectionné
            document.querySelector(`.village-tab[onclick="switchTab('${tabName}')"]`).classList.add('active');
            document.getElementById(tabName + 'TabContent').classList.add('active');
        };

        function closeVillageModal() {
            document.getElementById('villageModal').classList.remove('active');
            document.body.style.overflow = '';
        }

async function loadAdminLevelGeneric(levelConfig) {
    const cacheKey = currentCountry + '_' + levelConfig.key + '_data';
    try {
        let data;
        const cached = sessionStorage.getItem(cacheKey);
        if (cached) {
            try { data = JSON.parse(cached); } catch(e) { sessionStorage.removeItem(cacheKey); }
        }
        if (!data) {
            const res = await supabase
                .from(levelConfig.table)
                .select(levelConfig.idCol + ', ' + levelConfig.nameCol + ', geom');
            if (res.error) throw res.error;
            data = res.data;
            try { sessionStorage.setItem(cacheKey, JSON.stringify(data)); } catch(e) {}
        }
        if (!data || data.length === 0) return;

        const layerKey = levelConfig.key;
        mapDataCache[layerKey] = data;
        mapLayers[layerKey] = L.layerGroup();

        const zoom = map ? map.getZoom() : 7;
        const initialOpacity = levelConfig.minZoom > 0 ? (zoom >= levelConfig.minZoom ? 0.7 : 0) : 0.8;

        data.forEach(item => {
            if (item.geom) {
                const geometry = parseGeometry(item.geom);
                if (!geometry) return;

                const style = {
                    fillColor: 'transparent',
                    color: levelConfig.color,
                    weight: levelConfig.weight,
                    opacity: initialOpacity,
                    fillOpacity: 0,
                    interactive: true,
                };
                if (levelConfig.dashArray) style.dashArray = levelConfig.dashArray;

                const layer = L.geoJSON(geometry, {
                    style: style,
                    interactive: true,
                    pane: levelConfig.pane
                }).addTo(mapLayers[layerKey]);

                const area = calculateAreaFromGeometry(geometry);
                const areaText = typeof area === 'number' ? formatArea(area) : t('village.not_calculated');
                const name = item[levelConfig.nameCol] || t('popup.no_name');
                const typeLabel = t(levelConfig.labelKey) || levelConfig.key;

                layer.bindPopup(`
                    <div style="font-family: inherit;">
                        <h4 style="color: ${levelConfig.color}; margin-bottom: 8px;">
                            <i class="fas fa-map"></i> ${name}
                        </h4>
                        <p><strong>${t('popup.type')}:</strong> ${typeLabel}</p>
                        <p><strong>${t('popup.area')}:</strong> ${areaText}</p>
                    </div>
                `);
            }
        });

        map.addLayer(mapLayers[layerKey]);
        console.log(`✅ ${data.length} ${levelConfig.key} loaded`);

    } catch (error) {
        console.error(`Error loading ${levelConfig.key}:`, error);
        throw error;
    }
}

async function loadRegionsOptimized() {
    const levels = cc().adminLevels;
    if (levels[0]) await loadAdminLevelGeneric(levels[0]);
}

async function loadDepartementsOptimized() {
    const levels = cc().adminLevels;
    if (levels[1]) await loadAdminLevelGeneric(levels[1]);
}

async function loadArrondissementsOptimized() {
    const levels = cc().adminLevels;
    if (levels[2]) await loadAdminLevelGeneric(levels[2]);
}
        
        
             function loadLayersByZoom() {
            const zoom = map.getZoom();
            console.log(`🔊 Zoom: ${zoom}`);

            const levels = cc().adminLevels;
            levels.forEach(lv => {
                if (mapLayers[lv.key]) {
                    const opacity = lv.minZoom > 0 ? (zoom >= lv.minZoom ? 0.7 : 0) : 0.8;
                    mapLayers[lv.key].eachLayer(layer => {
                        layer.setStyle({ opacity: opacity, fillOpacity: 0 });
                    });
                }
            });

            if (mapLayers.villages) {
                mapLayers.villages.eachLayer(layer => {
                    layer.setStyle({ opacity: 0.8, fillOpacity: 0 });
                });
            }

            if (mapLayers.villagesPonctuels) {
                const vpVisible = zoom >= 10;
                if (vpVisible && !map.hasLayer(mapLayers.villagesPonctuels)) {
                    map.addLayer(mapLayers.villagesPonctuels);
                } else if (!vpVisible && map.hasLayer(mapLayers.villagesPonctuels)) {
                    map.removeLayer(mapLayers.villagesPonctuels);
                }
                if (vpVisible) {
                    const radius = zoom <= 11 ? 0.7 : zoom <= 13 ? 1 : zoom <= 15 ? 1.7 : zoom <= 17 ? 2.3 : 3;
                    const showLabels = zoom >= 12;
                    const fontSize = zoom <= 12 ? 8 : zoom <= 13 ? 9 : zoom <= 14 ? 10 : zoom <= 15 ? 11 : zoom <= 16 ? 13 : zoom <= 17 ? 15 : 17;
                    const bounds = map.getBounds();
                    mapLayers.villagesPonctuels.eachLayer(marker => {
                        if (marker.setRadius) marker.setRadius(radius);
                        const inView = bounds.contains(marker.getLatLng());
                        if (marker.vpData && marker.vpData.name && showLabels && inView) {
                            if (!marker.getTooltip()) {
                                marker.bindTooltip(marker.vpData.name, {
                                    permanent: true,
                                    direction: 'right',
                                    offset: [6, 0],
                                    className: 'vp-label'
                                });
                            }
                            const el = marker.getTooltip() ? marker.getTooltip().getElement() : null;
                            if (el) el.style.fontSize = fontSize + 'px';
                        } else if (marker.getTooltip()) {
                            marker.unbindTooltip();
                        }
                    });
                }
            }

            // ✅ Réappliquer la hiérarchie des clics
            applyClickHierarchy();
        }


        // GÉOLOCALISATION
        let watchId = null;
        let followUser = true;
        let firstLocationFix = true;

        function locateUser() {
            const button = document.getElementById('locateUser');

            // Si déjà actif, désactiver le suivi
            if (isLocating) {
                stopLocationTracking();
                showNotification(t('notif.geo_tracking_off'), 'info', 2000);
                return;
            }

            if (!navigator.geolocation) {
                showNotification(t('notif.geo_not_supported'), 'error');
                return;
            }

            isLocating = true;
            followUser = true;
            firstLocationFix = true;
            button.classList.add('locating');
            showNotification(t('notif.geo_searching'), 'info');

            // Utiliser watchPosition pour le suivi en temps réel
            watchId = navigator.geolocation.watchPosition(
                onLocationUpdate,
                onLocationError,
                {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 0
                }
            );

            // Arrêter le suivi de la vue quand l'utilisateur déplace la carte manuellement
            map.once('dragstart', () => {
                followUser = false;
            });
        }

        function onLocationUpdate(position) {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;
            const accuracy = position.coords.accuracy;
            const speed = position.coords.speed;
            const heading = position.coords.heading;

            const latlng = L.latLng(lat, lng);

            // Mettre à jour ou créer le cercle de précision
            if (userLocationAccuracy) {
                userLocationAccuracy.setLatLng(latlng);
                userLocationAccuracy.setRadius(accuracy);
            } else {
                userLocationAccuracy = L.circle(latlng, {
                    radius: accuracy,
                    className: 'user-location-accuracy',
                    interactive: false
                }).addTo(map);
            }

            // Mettre à jour ou créer le marqueur
            if (userLocationMarker) {
                userLocationMarker.setLatLng(latlng);
            } else {
                const locationIcon = L.divIcon({
                    className: 'user-location-marker',
                    iconSize: [20, 20],
                    iconAnchor: [10, 10]
                });
                userLocationMarker = L.marker(latlng, {
                    icon: locationIcon,
                    zIndexOffset: 1000
                }).addTo(map);
            }

            // Mettre à jour le popup
            const speedText = speed !== null ? `${(speed * 3.6).toFixed(1)} km/h` : 'N/A';
            userLocationMarker.bindPopup(`
                <div style="font-family: inherit; text-align: center;">
                    <h4 style="color: #007bff; margin-bottom: 8px;">
                        <i class="fas fa-crosshairs"></i> ${t('geo.your_position')}
                    </h4>
                    <p><strong>${t('geo.latitude')}:</strong> ${lat.toFixed(6)}</p>
                    <p><strong>${t('geo.longitude')}:</strong> ${lng.toFixed(6)}</p>
                    <p><strong>${t('geo.precision')}:</strong> ±${Math.round(accuracy)}m</p>
                    <p><strong>${t('geo.speed')}:</strong> ${speedText}</p>
                    <p style="font-size: 12px; color: #666; margin-top: 10px;">
                        <i class="fas fa-satellite-dish"></i> ${t('geo.tracking_active')}
                    </p>
                </div>
            `);

            // Centrer la carte sur la position (seulement si l'utilisateur n'a pas bougé la carte)
            if (followUser) {
                if (firstLocationFix) {
                    map.setView(latlng, Math.max(map.getZoom(), 15));
                    firstLocationFix = false;
                } else {
                    map.panTo(latlng, { animate: true, duration: 0.5 });
                }
            }

            // Mettre à jour le bouton
            const button = document.getElementById('locateUser');
            button.classList.remove('locating');
            button.classList.add('located');

            if (firstLocationFix === false && !userLocationMarker.isPopupOpen()) {
                // Ne pas forcer l'ouverture du popup à chaque mise à jour
            }

            if (firstLocationFix === true) {
                showNotification(t('notif.geo_found', {accuracy: Math.round(accuracy)}), 'success');
            }
        }

        function onLocationError(error) {
            let message = t('notif.geo_error');

            switch(error.code) {
                case error.PERMISSION_DENIED:
                    message = t('notif.geo_permission_denied');
                    break;
                case error.POSITION_UNAVAILABLE:
                    message = t('notif.geo_position_unavailable');
                    break;
                case error.TIMEOUT:
                    message = t('notif.geo_timeout');
                    if (isLocating) return;
                    break;
            }

            showNotification(message, 'error');
            stopLocationTracking();
        }

        function stopLocationTracking() {
            if (watchId !== null) {
                navigator.geolocation.clearWatch(watchId);
                watchId = null;
            }

            isLocating = false;
            followUser = false;

            const button = document.getElementById('locateUser');
            button.classList.remove('locating', 'located');

            if (userLocationMarker) {
                map.removeLayer(userLocationMarker);
                userLocationMarker = null;
            }
            if (userLocationAccuracy) {
                map.removeLayer(userLocationAccuracy);
                userLocationAccuracy = null;
            }
        }

    

        function clearActiveMeasurements() {
            if (isDistanceMeasuring) {
                stopDistanceMeasurement();
            }
            if (isAreaMeasuring) {
                stopAreaMeasurement();
            }

            distanceMarkers.forEach(marker => {
                if (map.hasLayer(marker)) map.removeLayer(marker);
            });
            distanceMarkers = [];

            measurementLines.forEach(line => {
                if (map.hasLayer(line)) map.removeLayer(line);
            });
            measurementLines = [];

            distanceSegmentLabels.forEach(label => {
                if (map.hasLayer(label)) map.removeLayer(label);
            });
            distanceSegmentLabels = [];
            distanceTotalDistance = 0;

            if (distanceTotalLabel) {
                if (map.hasLayer(distanceTotalLabel)) map.removeLayer(distanceTotalLabel);
                distanceTotalLabel = null;
            }

            if (distanceTempLine) {
                map.removeLayer(distanceTempLine);
                distanceTempLine = null;
            }

            map.closePopup();
        }

        function clearAllMeasurements() {
            clearActiveMeasurements();

            measurementPolygons.forEach(item => {
                if (map.hasLayer(item)) map.removeLayer(item);
            });
            measurementPolygons = [];

            measurementLayer.clearLayers();

            if (tempPolygon) {
                map.removeLayer(tempPolygon);
                tempPolygon = null;
            }

            map.closePopup();
            showNotification(t('notif.all_measures_cleared'), 'info');
        }

        let distanceTempLine = null;
        let distanceTotalDistance = 0;
        let distanceSegmentLabels = [];
        let distanceTotalLabel = null;

        let distanceClickTimeout = null;

        function startDistanceMeasurement() {
            clearActiveMeasurements();

            const button = document.getElementById('measureDistance');
            if (isDistanceMeasuring) {
                finishDistanceMeasurement();
                return;
            }

            isDistanceMeasuring = true;
            distanceTotalDistance = 0;
            distanceSegmentLabels = [];
            distanceTotalLabel = null;
            button.classList.add('active');

            map.doubleClickZoom.disable();
            showNotification(t('notif.measure_click_to_add'), 'info');

            map.on('click', onDistanceClick);
            map.on('dblclick', onDistanceFinish);
            map.on('mousemove', onDistanceMouseMove);
            map.getContainer().style.cursor = 'crosshair';
        }

        function stopDistanceMeasurement() {
            isDistanceMeasuring = false;
            document.getElementById('measureDistance').classList.remove('active');
            map.off('click', onDistanceClick);
            map.off('dblclick', onDistanceFinish);
            map.off('mousemove', onDistanceMouseMove);
            map.getContainer().style.cursor = '';
            map.doubleClickZoom.enable();

            if (distanceClickTimeout) {
                clearTimeout(distanceClickTimeout);
                distanceClickTimeout = null;
            }

            if (distanceTempLine) {
                map.removeLayer(distanceTempLine);
                distanceTempLine = null;
            }
        }

        function finishDistanceMeasurement() {
            if (distanceMarkers.length < 2) {
                stopDistanceMeasurement();
                if (distanceMarkers.length === 1) {
                    measurementLayer.removeLayer(distanceMarkers[0]);
                    distanceMarkers = [];
                }
                return;
            }

            // Remplacer le label total temporaire par un popup final
            if (distanceTotalLabel) {
                measurementLayer.removeLayer(distanceTotalLabel);
                distanceTotalLabel = null;
            }

            const lastPoint = distanceMarkers[distanceMarkers.length - 1].getLatLng();
            L.popup({
                closeButton: true,
                autoClose: false,
                className: 'measurement-tooltip'
            })
            .setLatLng(lastPoint)
            .setContent(`<strong>${t('measure.total')}: ${formatDistance(distanceTotalDistance)}</strong><br><small>${distanceMarkers.length} ${t('measure.points')}, ${distanceMarkers.length - 1} ${t('measure.segments')}</small>`)
            .openOn(map);

            showNotification(t('notif.total_distance', {distance: formatDistance(distanceTotalDistance)}), 'success');
            stopDistanceMeasurement();
        }

        function onDistanceClick(e) {
            if (!isDistanceMeasuring) return;

            L.DomEvent.stopPropagation(e);

            // Retarder l'ajout du point pour filtrer le double-clic
            if (distanceClickTimeout) clearTimeout(distanceClickTimeout);
            const latlng = e.latlng;
            distanceClickTimeout = setTimeout(() => {
                const marker = L.circleMarker(latlng, {
                    radius: 6,
                    color: '#ff4757',
                    fillColor: '#ff4757',
                    fillOpacity: 1,
                    weight: 2
                }).addTo(measurementLayer);

                distanceMarkers.push(marker);

                if (distanceMarkers.length >= 2) {
                    const prev = distanceMarkers[distanceMarkers.length - 2].getLatLng();
                    const curr = latlng;

                    const line = L.polyline([prev, curr], {
                        color: '#ff4757',
                        weight: 3,
                        dashArray: '8, 12'
                    }).addTo(measurementLayer);
                    measurementLines.push(line);

                    const segmentDist = calculateDistance(prev, curr);
                    distanceTotalDistance += segmentDist;

                    const midPoint = L.latLngBounds([prev, curr]).getCenter();
                    const segLabel = L.tooltip({
                        permanent: true,
                        direction: 'top',
                        className: 'measurement-tooltip',
                        offset: [0, -10]
                    })
                    .setLatLng(midPoint)
                    .setContent(formatDistance(segmentDist));
                    segLabel.addTo(measurementLayer);
                    distanceSegmentLabels.push(segLabel);

                    if (distanceTotalLabel) {
                        measurementLayer.removeLayer(distanceTotalLabel);
                    }
                    distanceTotalLabel = L.tooltip({
                        permanent: true,
                        direction: 'right',
                        className: 'measurement-tooltip distance-total-label',
                        offset: [10, 0]
                    })
                    .setLatLng(curr)
                    .setContent(`<strong>${t('measure.total')}: ${formatDistance(distanceTotalDistance)}</strong>`);
                    distanceTotalLabel.addTo(measurementLayer);
                }
            }, 200);
        }

        function onDistanceFinish(e) {
            if (!isDistanceMeasuring || distanceMarkers.length < 2) return;

            if (distanceClickTimeout) {
                clearTimeout(distanceClickTimeout);
                distanceClickTimeout = null;
            }

            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);
            finishDistanceMeasurement();
        }

        function onDistanceMouseMove(e) {
            if (!isDistanceMeasuring || distanceMarkers.length === 0) return;

            const lastPoint = distanceMarkers[distanceMarkers.length - 1].getLatLng();

            if (distanceTempLine) {
                map.removeLayer(distanceTempLine);
            }

            distanceTempLine = L.polyline([lastPoint, e.latlng], {
                color: '#ff4757',
                weight: 2,
                opacity: 0.5,
                dashArray: '5, 10'
            }).addTo(map);
        }

        let areaClickTimeout = null;

        function startAreaMeasurement() {
            clearActiveMeasurements();

            const button = document.getElementById('measureArea');
            if (isAreaMeasuring) {
                stopAreaMeasurement();
                return;
            }

            isAreaMeasuring = true;
            button.classList.add('active');
            polygonPoints = [];

            map.doubleClickZoom.disable();
            showNotification(t('notif.measure_draw_polygon'), 'info');

            map.on('click', onPolygonClick);
            map.on('dblclick', onPolygonFinish);
            map.on('mousemove', onPolygonMouseMove);
            map.getContainer().style.cursor = 'crosshair';
        }

        function stopAreaMeasurement() {
            isAreaMeasuring = false;
            document.getElementById('measureArea').classList.remove('active');

            map.off('click', onPolygonClick);
            map.off('dblclick', onPolygonFinish);
            map.off('mousemove', onPolygonMouseMove);
            map.getContainer().style.cursor = '';
            map.doubleClickZoom.enable();

            if (areaClickTimeout) {
                clearTimeout(areaClickTimeout);
                areaClickTimeout = null;
            }

            if (tempPolygon) {
                map.removeLayer(tempPolygon);
                tempPolygon = null;
            }
        }

        function onPolygonClick(e) {
            if (!isAreaMeasuring) return;

            L.DomEvent.stopPropagation(e);

            // Retarder l'ajout du point pour filtrer le double-clic
            if (areaClickTimeout) clearTimeout(areaClickTimeout);
            areaClickTimeout = setTimeout(() => {
                polygonPoints.push(e.latlng);

                const marker = L.circleMarker(e.latlng, {
                    radius: 5,
                    color: '#4CAF50',
                    fillColor: '#4CAF50',
                    fillOpacity: 1,
                    weight: 2
                }).addTo(measurementLayer);

                measurementPolygons.push(marker);

                if (polygonPoints.length >= 2) {
                    if (tempPolygon) {
                        map.removeLayer(tempPolygon);
                    }
                    tempPolygon = L.polyline(polygonPoints, {
                        color: '#4CAF50',
                        weight: 3,
                        opacity: 0.7,
                        dashArray: '5, 10'
                    }).addTo(map);
                }
            }, 200);
        }

        function onPolygonFinish(e) {
            if (!isAreaMeasuring || polygonPoints.length < 3) return;

            // Annuler le clic en attente (le dernier clic du double-clic)
            if (areaClickTimeout) {
                clearTimeout(areaClickTimeout);
                areaClickTimeout = null;
            }

            L.DomEvent.stopPropagation(e);
            L.DomEvent.preventDefault(e);

            if (tempPolygon) {
                map.removeLayer(tempPolygon);
                tempPolygon = null;
            }

            const finalPolygon = L.polygon(polygonPoints, {
                color: '#4CAF50',
                weight: 3,
                fillColor: '#4CAF50',
                fillOpacity: 0.2
            }).addTo(measurementLayer);

            measurementPolygons.push(finalPolygon);

            const area = calculatePolygonArea(polygonPoints);
            const center = finalPolygon.getBounds().getCenter();

            L.popup({
                closeButton: true,
                autoClose: false,
                className: 'measurement-tooltip'
            })
            .setLatLng(center)
            .setContent(`<strong>${t('measure.surface')}: ${formatArea(area)}</strong>`)
            .openOn(map);

            showNotification(t('notif.area_result', {area: formatArea(area)}), 'success');

            stopAreaMeasurement();
        }

        function onPolygonMouseMove(e) {
            if (!isAreaMeasuring || polygonPoints.length === 0) return;
            
            if (tempPolygon) {
                map.removeLayer(tempPolygon);
            }
            
            const tempPoints = [...polygonPoints, e.latlng];
            tempPolygon = L.polyline(tempPoints, {
                color: '#4CAF50',
                weight: 2,
                opacity: 0.5,
                dashArray: '5, 10'
            }).addTo(map);
        }

        // ================================================================
        // SYSTEME D'IMPRESSION AVANCE - MODAL & EXPORT
        // ================================================================

        function openPrintModal() {
            console.log('Ouverture du modal d\'impression');
            const modal = document.getElementById('printModal');
            modal.classList.remove('minimized');
            modal.classList.add('active');

            // Initialize preview map
            setTimeout(() => {
                initPreviewMap();
                if (previewMap) previewMap.invalidateSize();
                if (printBounds) updatePreviewFromBounds();
            }, 300);

            const previewDateLoc = (window.getLang && getLang() === 'en') ? 'en-US' : 'fr-FR';
            document.getElementById('previewDate').textContent = new Date().toLocaleDateString(previewDateLoc);
            updatePrintPreview();
        }

        function closePrintModal() {
            const modal = document.getElementById('printModal');
            modal.classList.remove('active');
            modal.classList.remove('minimized');
            let valBtn = document.getElementById('validateZoneBtn');
            if (valBtn) valBtn.classList.remove('visible');
        }

        function updatePrintPreview() {
            const titleInput = document.getElementById('mapTitle');
            const defaultTitle = t('print.map_title_default');
            const title = titleInput ? titleInput.value || defaultTitle : defaultTitle;

            const previewTitleEl = document.getElementById('previewTitle');
            if (previewTitleEl) previewTitleEl.textContent = title;
            printConfig.title = title;

            const previewFormatEl = document.getElementById('previewFormat');
            if (previewFormatEl) previewFormatEl.textContent = printConfig.format;

            // Visibility of display elements
            const northArrow = document.getElementById('previewNorthArrow');
            const scaleElement = document.getElementById('previewScale');
            const showNorthArrowCb = document.getElementById('showNorthArrow');
            const showScaleCb = document.getElementById('showScale');

            if (northArrow && showNorthArrowCb) {
                northArrow.style.display = showNorthArrowCb.checked ? 'flex' : 'none';
            }
            if (scaleElement && showScaleCb) {
                scaleElement.style.display = showScaleCb.checked ? 'block' : 'none';
            }

            // Update summary
            updateSummaryFields();

            // Update preview map if bounds exist
            if (printBounds && previewMap) {
                updatePreviewFromBounds();
            }
        }

        function updateSummaryFields() {
            const summaryFormat = document.getElementById('summaryFormat');
            const summaryFileType = document.getElementById('summaryFileType');
            const summaryPrice = document.getElementById('summaryPrice');
            const outputFormat = document.getElementById('outputFormat');

            if (summaryFormat) summaryFormat.textContent = printConfig.format;
            if (summaryFileType && outputFormat) summaryFileType.textContent = outputFormat.value.toUpperCase();
            if (summaryPrice) summaryPrice.textContent = `${printConfig.price.toLocaleString()} ${cc().currency}`;

            // Scale is calculated automatically
            calculateAndDisplayScale();
        }

        function selectFormat(format, price) {
            document.querySelectorAll('.format-option').forEach(option => {
                option.classList.remove('selected');
            });
            const el = document.querySelector(`[data-format="${format}"]`);
            if (el) el.classList.add('selected');

            printConfig.format = format;

            const customGroup = document.getElementById('customSizeGroup');
            if (format === 'custom') {
                customGroup.style.display = 'block';
                const w = parseFloat(document.getElementById('customWidth').value) || 1;
                const h = parseFloat(document.getElementById('customHeight').value) || 1.5;
                printConfig.price = getEffectivePrice(Math.round(w * h * 10000));
            } else {
                customGroup.style.display = 'none';
                printConfig.price = getEffectivePrice(price);
            }

            updatePrintPreview();
        }

        function updateCustomPrice() {
            if (printConfig.format !== 'custom') return;
            const w = parseFloat(document.getElementById('customWidth').value) || 1;
            const h = parseFloat(document.getElementById('customHeight').value) || 1.5;
            const cw = Math.max(1, Math.min(2, w));
            const ch = Math.max(1, Math.min(2, h));
            printConfig.price = getEffectivePrice(Math.round(cw * ch * 10000));
            updateSummaryFields();
            calculateAndDisplayScale();
        }

        function setScale(scale) {
            // Scale is now auto-calculated, but keep for compatibility
            printConfig.scale = parseInt(scale);
            const scaleEl = document.getElementById('summaryScale');
            if (scaleEl) scaleEl.textContent = `1:${parseInt(scale).toLocaleString()}`;
        }

        // ================================================================
        // PAYMENT SYSTEM (Flutterwave)
        // ================================================================

        let cachedExportBlob = null;
        let cachedExportFileName = '';

        async function proceedToPayment() {
            if (!printBounds) {
                showNotification(t('notif.select_zone'), 'warning');
                return;
            }

            printConfig.title = document.getElementById('mapTitle').value || t('print.map_title_default');
            printConfig.outputFormat = document.getElementById('outputFormat').value;
            printConfig.showNorthArrow = document.getElementById('showNorthArrow').checked;
            printConfig.showScale = document.getElementById('showScale').checked;
            printConfig.showLegend = document.getElementById('showLegend').checked;
            printConfig.showCoordinates = document.getElementById('showCoordinates').checked;
            printConfig.bounds = printBounds;

            closePrintModal();

            // Pre-generate the map export BEFORE payment
            const success = await preGenerateExport();
            if (!success) {
                showNotification(t('notif.map_prep_error'), 'error');
                return;
            }

            // If subscriber, skip payment
            if (userGeoInfo.hasActiveSubscription) {
                showNotification(t('notif.subscriber_export'), 'success');
                downloadCachedExport();
                return;
            }

            // Show payment modal
            const paymentModal = document.getElementById('paymentModal');
            paymentModal.classList.add('active');
            document.getElementById('paymentAmount').textContent = `${printConfig.price.toLocaleString()} ${cc().currency}`;
            document.getElementById('paymentDetails').textContent =
                `Format ${printConfig.format} - ${printConfig.outputFormat.toUpperCase()}`;

            // Show pricing info for outside Africa
            let geoNotice = document.getElementById('geoPricingNotice');
            if (!geoNotice) {
                geoNotice = document.createElement('div');
                geoNotice.id = 'geoPricingNotice';
                geoNotice.style.cssText = 'background:#fff3cd;border:1px solid #ffc107;border-radius:8px;padding:10px;margin:10px 0;font-size:13px;color:#856404;';
                const payInfo = document.querySelector('.payment-info');
                if (payInfo) payInfo.after(geoNotice);
            }
            if (isOutsideAfrica()) {
                geoNotice.innerHTML = t('print.geo_intl_rate');
                geoNotice.style.display = 'block';
            } else {
                geoNotice.style.display = 'none';
            }
        }

        async function preGenerateExport() {
            const loadingOverlay = document.getElementById('loadingOverlay');
            const loadingContent = loadingOverlay.querySelector('.loading-content');
            loadingContent.innerHTML = `
                <div class="spinner"></div>
                <h3>${t('print.progress_preparing')}</h3>
                <p id="exportProgress">${t('print.progress_adjusting')}</p>
                <div style="width:80%; margin:15px auto; background:#e0e0e0; border-radius:10px; height:10px; overflow:hidden;">
                    <div id="exportProgressBar" style="width:0%; height:100%; background:#4a7c59; border-radius:10px; transition: width 0.3s;"></div>
                </div>
            `;
            loadingOverlay.classList.add('active');

            const progressEl = document.getElementById('exportProgress');
            const progressBar = document.getElementById('exportProgressBar');

            try {
                const bounds = printBounds || map.getBounds();
                const paperWm = getPaperWidthMeters();
                const paperHm = getPaperHeightMeters();

                // DPI and pixel dimensions matching paper proportions
                const dpi = 150;
                const pxWidth = Math.round(paperWm * 39.3701 * dpi);
                const pxHeight = Math.round(paperHm * 39.3701 * dpi);
                const maxPx = 4096;
                const scaleFactor = Math.min(1, maxPx / Math.max(pxWidth, pxHeight));
                const finalW = Math.round(pxWidth * scaleFactor);
                const finalH = Math.round(pxHeight * scaleFactor);

                // Margins for title and footer (legend is overlaid)
                const titleH = Math.round(finalH * 0.05);
                const footerH = Math.round(finalH * 0.04);
                const mapW = finalW;
                const mapH = finalH - titleH - footerH;

                progressEl.textContent = t('print.progress_adjusting');
                progressBar.style.width = '10%';

                // Hide print overlay temporarily
                if (printOverlayEl) { printOverlayEl.style.display = 'none'; }

                // Add labels to map temporarily
                progressEl.textContent = t('print.progress_labels');
                progressBar.style.width = '20%';
                const tempLabels = addExportLabels(bounds);

                map.fitBounds(bounds, { animate: false, padding: [0, 0] });
                map.invalidateSize();

                progressEl.textContent = t('print.progress_tiles');
                progressBar.style.width = '35%';
                await waitForTilesLoaded();

                progressEl.textContent = t('print.progress_capture');
                progressBar.style.width = '55%';

                const mapContainer = document.getElementById('map');
                const mapCanvas = await html2canvas(mapContainer, {
                    useCORS: true,
                    allowTaint: true,
                    scale: Math.max(1, Math.ceil(mapW / mapContainer.offsetWidth)),
                    logging: false,
                    backgroundColor: '#ffffff'
                });

                // Remove temporary labels, restore overlay
                tempLabels.forEach(l => map.removeLayer(l));
                if (printOverlayEl) { printOverlayEl.style.display = ''; }

                progressEl.textContent = t('print.progress_composing');
                progressBar.style.width = '75%';

                // Create final canvas with proper paper proportions
                const finalCanvas = document.createElement('canvas');
                finalCanvas.width = finalW;
                finalCanvas.height = finalH;
                const ctx = finalCanvas.getContext('2d');

                // Background white
                ctx.fillStyle = '#ffffff';
                ctx.fillRect(0, 0, finalW, finalH);

                // Draw title bar
                ctx.fillStyle = '#2c5530';
                ctx.fillRect(0, 0, finalW, titleH);
                ctx.fillStyle = '#ffffff';
                ctx.font = `bold ${Math.round(titleH * 0.55)}px "Segoe UI", sans-serif`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(printConfig.title, finalW / 2, titleH / 2);

                // Draw map image (cropped to paper proportions)
                const srcRatio = mapCanvas.width / mapCanvas.height;
                const destRatio = mapW / mapH;
                let sx = 0, sy = 0, sw = mapCanvas.width, sh = mapCanvas.height;
                if (srcRatio > destRatio) {
                    sw = Math.round(mapCanvas.height * destRatio);
                    sx = Math.round((mapCanvas.width - sw) / 2);
                } else {
                    sh = Math.round(mapCanvas.width / destRatio);
                    sy = Math.round((mapCanvas.height - sh) / 2);
                }
                ctx.drawImage(mapCanvas, sx, sy, sw, sh, 0, titleH, mapW, mapH);

                // Draw legend as overlay (bottom-left corner of map area)
                if (printConfig.showLegend) {
                    const legendItems = currentCountry === 'ug' ? [
                        { color: '#d62728', label: t('print.legend_regions'), dash: false },
                        { color: '#000000', label: t('print.legend_districts'), dash: false },
                        { color: '#cc6600', label: t('print.legend_villages'), dash: true }
                    ] : [
                        { color: '#d62728', label: t('print.legend_regions'), dash: false },
                        { color: '#000000', label: t('print.legend_departements'), dash: false },
                        { color: '#8B008B', label: t('print.legend_arrondissements'), dash: true },
                        { color: '#cc6600', label: t('print.legend_villages'), dash: true }
                    ];

                    const lFontSize = Math.round(Math.min(finalW, finalH) * 0.018);
                    const lPad = Math.round(lFontSize * 0.8);
                    const lItemH = Math.round(lFontSize * 1.6);
                    const lLineW = Math.round(lFontSize * 2);
                    const lTitleH = Math.round(lFontSize * 2);
                    const lW = Math.round(lFontSize * 10);
                    const lH = lTitleH + legendItems.length * lItemH + lPad * 2;
                    const lx = lPad + 10;
                    const ly = titleH + mapH - lH - 10;

                    // Background with rounded corners
                    ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
                    ctx.strokeStyle = '#ccc';
                    ctx.lineWidth = 1;
                    ctx.beginPath();
                    ctx.roundRect(lx, ly, lW, lH, 6);
                    ctx.fill();
                    ctx.stroke();

                    // Title
                    ctx.fillStyle = '#2c5530';
                    ctx.font = `bold ${lFontSize}px "Segoe UI", sans-serif`;
                    ctx.textAlign = 'left';
                    ctx.textBaseline = 'top';
                    ctx.fillText(t('print.legend_title'), lx + lPad, ly + lPad);

                    // Items
                    let itemY = ly + lPad + lTitleH;
                    ctx.font = `${Math.round(lFontSize * 0.85)}px "Segoe UI", sans-serif`;
                    legendItems.forEach(item => {
                        ctx.strokeStyle = item.color;
                        ctx.lineWidth = 2;
                        if (item.dash) ctx.setLineDash([5, 3]);
                        else ctx.setLineDash([]);
                        ctx.beginPath();
                        ctx.moveTo(lx + lPad, itemY + lItemH / 2);
                        ctx.lineTo(lx + lPad + lLineW, itemY + lItemH / 2);
                        ctx.stroke();
                        ctx.setLineDash([]);
                        ctx.fillStyle = '#333';
                        ctx.fillText(item.label, lx + lPad + lLineW + 8, itemY + 2);
                        itemY += lItemH;
                    });
                }

                // Draw footer
                const fy = finalH - footerH;
                ctx.fillStyle = '#f0f0f0';
                ctx.fillRect(0, fy, finalW, footerH);
                ctx.strokeStyle = '#ccc';
                ctx.lineWidth = 1;
                ctx.beginPath(); ctx.moveTo(0, fy); ctx.lineTo(finalW, fy); ctx.stroke();

                ctx.fillStyle = '#333';
                ctx.font = `${Math.round(footerH * 0.45)}px "Segoe UI", sans-serif`;
                ctx.textAlign = 'left';
                ctx.textBaseline = 'middle';
                const dateLoc = (window.getLang && getLang() === 'en') ? 'en-US' : 'fr-FR';
                const scaleText = printConfig.scale ? `${t('print.footer_scale')}: 1:${printConfig.scale.toLocaleString()}` : '';
                ctx.fillText(scaleText, 10, fy + footerH / 2);

                ctx.textAlign = 'center';
                ctx.fillText(`Format: ${printConfig.format === 'custom' ? (paperWm + 'm x ' + paperHm + 'm') : printConfig.format}`, finalW / 2, fy + footerH / 2);

                ctx.textAlign = 'right';
                ctx.fillText(`MonVillage - ${new Date().toLocaleDateString(dateLoc)}`, finalW - 10, fy + footerH / 2);

                // Draw north arrow if enabled
                if (printConfig.showNorthArrow) {
                    const naSize = Math.round(Math.min(mapW, mapH) * 0.05);
                    const nax = mapW - naSize - 10;
                    const nay = titleH + 10;
                    ctx.fillStyle = 'rgba(255,255,255,0.85)';
                    ctx.beginPath();
                    ctx.arc(nax + naSize/2, nay + naSize/2, naSize/2, 0, Math.PI * 2);
                    ctx.fill();
                    ctx.strokeStyle = '#333';
                    ctx.lineWidth = 1;
                    ctx.stroke();
                    ctx.fillStyle = '#333';
                    ctx.font = `bold ${Math.round(naSize * 0.6)}px "Segoe UI", sans-serif`;
                    ctx.textAlign = 'center';
                    ctx.textBaseline = 'middle';
                    ctx.fillText('N', nax + naSize/2, nay + naSize/2 - 2);
                    // Arrow
                    ctx.beginPath();
                    ctx.moveTo(nax + naSize/2, nay + 3);
                    ctx.lineTo(nax + naSize/2 - 3, nay + naSize * 0.3);
                    ctx.lineTo(nax + naSize/2 + 3, nay + naSize * 0.3);
                    ctx.closePath();
                    ctx.fill();
                }

                progressEl.textContent = t('print.progress_generating');
                progressBar.style.width = '90%';

                cachedExportFileName = generateFileName();

                if (printConfig.outputFormat === 'pdf') {
                    const { jsPDF } = window.jspdf;
                    const orientation = (paperWm > paperHm) ? 'landscape' : 'portrait';
                    const pdf = new jsPDF({
                        orientation: orientation,
                        unit: 'mm',
                        format: printConfig.format !== 'custom'
                            ? printConfig.format.toLowerCase()
                            : [paperWm * 1000, paperHm * 1000]
                    });
                    const imgData = finalCanvas.toDataURL('image/jpeg', 0.95);
                    const pdfW = pdf.internal.pageSize.getWidth();
                    const pdfH = pdf.internal.pageSize.getHeight();
                    pdf.addImage(imgData, 'JPEG', 0, 0, pdfW, pdfH);
                    cachedExportBlob = pdf.output('blob');
                } else {
                    cachedExportBlob = await new Promise(resolve => {
                        finalCanvas.toBlob(resolve, 'image/png');
                    });
                }

                progressBar.style.width = '100%';
                progressEl.textContent = t('print.progress_ready');
                await new Promise(r => setTimeout(r, 800));
                loadingOverlay.classList.remove('active');
                return true;

            } catch (error) {
                console.error('Erreur pre-generation:', error);
                loadingOverlay.classList.remove('active');
                cachedExportBlob = null;
                return false;
            }
        }

        // Add labels for admin units visible within bounds
        function addExportLabels(bounds) {
            const labels = [];
            const layerConfigs = cc().adminLevels.map(lv => ({
                data: mapDataCache[lv.key], nameKey: lv.nameCol, color: lv.color, minArea: lv.minZoom > 6 ? 0.02 : lv.minZoom > 0 ? 0.1 : 0.5
            }));
            layerConfigs.push({ data: mapDataCache.villages, nameKey: cc().villageNameCol, color: '#cc6600', minArea: 0 });

            layerConfigs.forEach(config => {
                if (!config.data) return;
                config.data.forEach(item => {
                    if (!item.geom || !item[config.nameKey]) return;
                    const geom = parseGeometry(item.geom);
                    if (!geom) return;

                    const tempLayer = L.geoJSON(geom);
                    const itemBounds = tempLayer.getBounds();
                    if (!itemBounds.isValid()) return;

                    // Check if this entity intersects the export bounds
                    if (!bounds.intersects(itemBounds)) return;

                    const center = itemBounds.getCenter();
                    if (!bounds.contains(center)) return;

                    // Create label with white background (halo effect)
                    const label = L.tooltip({
                        permanent: true,
                        direction: 'center',
                        className: 'export-label',
                        offset: [0, 0]
                    })
                    .setLatLng(center)
                    .setContent(`<span style="color:${config.color}; font-weight:bold; text-shadow: -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff, 0 -2px 0 #fff, 0 2px 0 #fff, -2px 0 0 #fff, 2px 0 0 #fff;">${item[config.nameKey]}</span>`);
                    label.addTo(map);
                    labels.push(label);
                });
            });

            return labels;
        }

        function cancelPayment() {
            const paymentModal = document.getElementById('paymentModal');
            paymentModal.classList.remove('active');
            openPrintModal();
        }

        function selectPaymentMethod(method) {
            selectedPaymentMethod = method;
            document.querySelectorAll('.payment-method').forEach(el => {
                el.classList.remove('selected');
            });
            const methodEl = document.querySelector(`[data-method="${method}"]`);
            if (methodEl) methodEl.classList.add('selected');

            const fieldPhone = document.getElementById('field-phone');
            const fieldName = document.getElementById('field-name');
            if (method === 'mobilemoney') {
                fieldPhone.style.display = 'block';
                fieldName.style.display = 'none';
            } else if (method === 'card') {
                fieldPhone.style.display = 'none';
                fieldName.style.display = 'block';
            }

            const confirmButton = document.getElementById('confirmPayment');
            if (method === 'mobilemoney') {
                confirmButton.innerHTML = '<i class="fas fa-mobile-alt"></i> ' + t('payment.pay_mobile');
            } else if (method === 'card') {
                confirmButton.innerHTML = '<i class="fas fa-credit-card"></i> ' + t('payment.pay_card');
            }
        }

        let paymentInitiated = false;

        async function processPayment() {
            try {
                document.getElementById('paymentSpinner').style.display = 'block';
                document.getElementById('confirmPayment').disabled = true;
                paymentInitiated = false;

                const txRef = `PRINT_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

                const defaultPhone = cc().phonePrefix + '000000000';
                const customerPhone = document.getElementById('customer-phone').value.trim() || defaultPhone;
                const customerName = document.getElementById('customer-name').value.trim() || 'Client MonVillage';

                FlutterwaveCheckout({
                    public_key: CONFIG.flutterwave.publicKey,
                    tx_ref: txRef,
                    amount: printConfig.price,
                    currency: cc().currency,
                    payment_options: "card,mobilemoney,ussd",
                    customer: {
                        email: "client@monvillage.cm",
                        phone_number: customerPhone,
                        name: customerName
                    },
                    customizations: {
                        title: "MonVillage - " + t('print.export_title'),
                        description: `${t('print.export_title')} ${printConfig.format} - ${printConfig.outputFormat.toUpperCase()}`,
                        logo: ""
                    },
                    meta: {
                        print_format: printConfig.format,
                        print_title: printConfig.title
                    },
                    callback: function(data) {
                        console.log('Reponse Flutterwave:', data);
                        if (data.status === 'successful' || data.status === 'completed') {
                            paymentInitiated = true;
                            handlePaymentSuccess(data, txRef, data.payment_type || selectedPaymentMethod);
                        } else {
                            console.warn('Paiement non abouti, statut:', data.status);
                            document.getElementById('paymentSpinner').style.display = 'none';
                            document.getElementById('confirmPayment').disabled = false;
                            showNotification(t('notif.payment_not_completed'), 'error');
                        }
                    },
                    onclose: function() {
                        console.log('Fenetre Flutterwave fermee');
                        if (!paymentInitiated) {
                            document.getElementById('paymentSpinner').style.display = 'none';
                            document.getElementById('confirmPayment').disabled = false;
                            document.getElementById('paymentModal').classList.remove('active');
                            cachedExportBlob = null;
                            cachedExportFileName = '';
                            showNotification(t('notif.payment_cancelled'), 'info');
                        }
                    }
                });

            } catch (error) {
                console.error('Erreur lors du paiement:', error);
                showNotification(t('notif.payment_processing_error'), 'error');
                document.getElementById('paymentSpinner').style.display = 'none';
                document.getElementById('confirmPayment').disabled = false;
            }
        }

        async function handlePaymentSuccess(paymentData, txRef, paymentType = 'flutterwave') {
            console.log(`Paiement confirme via ${paymentType}`, paymentData);

            let successMessage = t('notif.payment_success');
            if (paymentType === 'mobilemoney') {
                successMessage = t('notif.payment_mobile_success');
            } else if (paymentType === 'card') {
                successMessage = t('notif.payment_card_success');
            } else if (paymentType === 'ussd') {
                successMessage = t('notif.payment_ussd_success');
            }

            try {
                // Record payment in Supabase
                if (supabase) {
                    const customerPhone = document.getElementById('customer-phone').value.trim();
                    const customerName = document.getElementById('customer-name').value.trim();
                    let contactInfo = '';
                    if (paymentType === 'mobilemoney' || paymentType === 'mobile_money') {
                        contactInfo = customerPhone || 'Mobile';
                    } else if (paymentType === 'card') {
                        contactInfo = customerName || 'Card';
                    } else {
                        contactInfo = customerPhone || customerName || '';
                    }

                    const paymentRecord = {
                        transaction_id: txRef,
                        amount: printConfig.price,
                        currency: cc().currency,
                        status: 'success',
                        payment_method: paymentType || 'flutterwave',
                        user_session: contactInfo,
                        flutterwave_tx_ref: txRef,
                        flutterwave_tx_id: paymentData.transaction_id?.toString() || null,
                        print_format: printConfig.format,
                        print_title: printConfig.title,
                        map_bounds: printBounds ? JSON.stringify({
                            north: printBounds.getNorth(),
                            south: printBounds.getSouth(),
                            east: printBounds.getEast(),
                            west: printBounds.getWest()
                        }) : null
                    };
                    const { error } = await supabase.from('payments').insert(paymentRecord);
                    if (error) {
                        console.error('Erreur enregistrement paiement:', error);
                    }
                }

                document.getElementById('paymentModal').classList.remove('active');
                showNotification(successMessage, 'success');

                // Download the pre-generated export
                downloadCachedExport();

            } catch (error) {
                console.error('Erreur post-paiement:', error);
                showNotification(t('notif.payment_ok_export_error'), 'warning');
            }
        }

        function handlePaymentCancel() {
            document.getElementById('paymentSpinner').style.display = 'none';
            document.getElementById('confirmPayment').disabled = false;
            showNotification(t('notif.payment_cancelled_short'), 'info');
            cachedExportBlob = null;
            cachedExportFileName = '';
        }


        function downloadCachedExport() {
            if (!cachedExportBlob) {
                showNotification(t('notif.export_error'), 'error');
                return;
            }

            const url = URL.createObjectURL(cachedExportBlob);
            const link = document.createElement('a');
            link.href = url;
            link.download = cachedExportFileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            showNotification(t('notif.map_exported', {filename: cachedExportFileName}), 'success', 6000);
            cachedExportBlob = null;
            cachedExportFileName = '';
            clearPrintAreaSelection();
        }

        // ================================================================
        // MAP EXPORT - captures the visible map directly
        // ================================================================

        async function generateMapExport() {
            const loadingOverlay = document.getElementById('loadingOverlay');
            const loadingContent = loadingOverlay.querySelector('.loading-content');
            loadingContent.innerHTML = `
                <div class="spinner"></div>
                <h3>${t('print.progress_preparing')}</h3>
                <p id="exportProgress">${t('print.progress_adjusting')}</p>
                <div style="width:80%; margin:15px auto; background:#e0e0e0; border-radius:10px; height:10px; overflow:hidden;">
                    <div id="exportProgressBar" style="width:0%; height:100%; background:#4a7c59; border-radius:10px; transition: width 0.3s;"></div>
                </div>
            `;
            loadingOverlay.classList.add('active');

            const progressEl = document.getElementById('exportProgress');
            const progressBar = document.getElementById('exportProgressBar');

            try {
                const bounds = printBounds || map.getBounds();

                // Step 1: Fit map to selected bounds
                progressEl.textContent = t('print.progress_adjusting');
                progressBar.style.width = '10%';

                // Hide print overlay temporarily
                const hadOverlay = !!printOverlayEl;
                if (printOverlayEl) { printOverlayEl.style.display = 'none'; }

                map.fitBounds(bounds, { animate: false, padding: [10, 10] });

                // Step 2: Wait for tiles to render
                progressEl.textContent = t('print.progress_tiles');
                progressBar.style.width = '30%';
                await waitForTilesLoaded();

                progressEl.textContent = t('print.progress_capture');
                progressBar.style.width = '60%';

                // Step 3: Capture the map container
                const mapContainer = document.getElementById('map');
                const canvas = await html2canvas(mapContainer, {
                    useCORS: true,
                    allowTaint: true,
                    scale: 2,
                    logging: false,
                    backgroundColor: '#ffffff'
                });

                progressEl.textContent = t('print.progress_generating');
                progressBar.style.width = '85%';

                const fileName = generateFileName();

                if (printConfig.outputFormat === 'pdf') {
                    const { jsPDF } = window.jspdf;
                    const paperWidthM = getPaperWidthMeters();
                    const paperHeightM = getPaperHeightMeters();
                    const orientation = (canvas.width > canvas.height) ? 'landscape' : 'portrait';
                    const pdf = new jsPDF({
                        orientation: orientation,
                        unit: 'mm',
                        format: printConfig.format !== 'custom'
                            ? printConfig.format.toLowerCase()
                            : [paperWidthM * 1000, paperHeightM * 1000]
                    });

                    const imgData = canvas.toDataURL('image/jpeg', 0.92);
                    const pdfWidth = pdf.internal.pageSize.getWidth();
                    const pdfHeight = pdf.internal.pageSize.getHeight();

                    pdf.setFontSize(14);
                    pdf.text(printConfig.title, pdfWidth / 2, 8, { align: 'center' });

                    pdf.addImage(imgData, 'JPEG', 3, 12, pdfWidth - 6, pdfHeight - 20);

                    pdf.setFontSize(7);
                    const dateLoc2 = (window.getLang && getLang() === 'en') ? 'en-US' : 'fr-FR';
                    const scaleText = printConfig.scale ? `${t('print.footer_scale')}: 1:${printConfig.scale.toLocaleString()}` : '';
                    pdf.text(scaleText, 5, pdfHeight - 3);
                    pdf.text(`MonVillage - ${new Date().toLocaleDateString(dateLoc2)}`, pdfWidth - 40, pdfHeight - 3);

                    pdf.save(fileName);
                } else {
                    // PNG download
                    canvas.toBlob(function(blob) {
                        const url = URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.href = url;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                    }, 'image/png');
                }

                progressBar.style.width = '100%';
                progressEl.textContent = t('print.progress_ready');

                await new Promise(r => setTimeout(r, 500));
                loadingOverlay.classList.remove('active');
                showNotification(t('notif.export_success', {filename: fileName}), 'success', 6000);
                clearPrintAreaSelection();

            } catch (error) {
                console.error('Erreur export:', error);
                loadingOverlay.classList.remove('active');
                if (printOverlayEl) { printOverlayEl.style.display = ''; }
                showNotification(t('notif.export_cross_origin_error'), 'error', 8000);
            }
        }

        function waitForTilesLoaded() {
            return new Promise(resolve => {
                let checks = 0;
                const maxChecks = 30;
                function check() {
                    checks++;
                    const tiles = document.querySelectorAll('#map .leaflet-tile-loaded');
                    const loading = document.querySelectorAll('#map .leaflet-tile:not(.leaflet-tile-loaded)');
                    if (loading.length === 0 || checks >= maxChecks) {
                        setTimeout(resolve, 500);
                    } else {
                        setTimeout(check, 200);
                    }
                }
                setTimeout(check, 500);
            });
        }

        function getPaperHeightMeters() {
            if (printConfig.format === 'custom') {
                return parseFloat(document.getElementById('customHeight').value) || 1.5;
            }
            const selectedOption = document.querySelector('.format-option.selected');
            if (selectedOption) {
                return parseFloat(selectedOption.dataset.h) || 0.594;
            }
            return 0.594; // default A2 height
        }

        function getActiveLayers() {
            const activeLayers = [];
            document.querySelectorAll('.layer-toggle.active').forEach(toggle => {
                activeLayers.push(toggle.dataset.layer);
            });
            return activeLayers;
        }

        function generateFileName() {
            const timestamp = new Date().toISOString().slice(0, 19).replace(/:/g, '-');
            const title = printConfig.title.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 30);
            return `${title}_${printConfig.format}_${timestamp}.${printConfig.outputFormat}`;
        }

        // AUTRES FONCTIONS
        function toggleSidebar() {
            const sidebar = document.getElementById('sidebar');
            const overlay = document.getElementById('sidebarOverlay');
            if (window.innerWidth <= 768) {
                if (sidebar.classList.contains('open')) {
                    closeSidebar();
                } else {
                    sidebar.classList.add('open');
                    overlay.classList.add('active');
                    document.body.style.overflow = 'hidden';
                }
            } else {
                sidebar.classList.toggle('collapsed');
            }
        }

        function closeSidebar() {
            const sidebar = document.getElementById('sidebar');
            const overlay = document.getElementById('sidebarOverlay');
            sidebar.classList.remove('open');
            overlay.classList.remove('active');
            document.body.style.overflow = '';
        }

        function toggleSatelliteView() {
            const button = document.getElementById('toggleSatellite');
            if (currentBaseLayer === 'standard') {
                map.removeLayer(baseLayers.standard);
                map.addLayer(baseLayers.satellite);
                currentBaseLayer = 'satellite';
                button.classList.add('active');
            } else {
                map.removeLayer(baseLayers.satellite);
                map.addLayer(baseLayers.standard);
                currentBaseLayer = 'standard';
                button.classList.remove('active');
            }
        }

        // VUE 3D
        let map3dInstance = null;

        function open3DView() {
            const modal = document.getElementById('modal3D');
            modal.style.display = 'block';
            document.body.style.overflow = 'hidden';

            const center = map.getCenter();
            const zoom = map.getZoom();

            if (map3dInstance) {
                map3dInstance.remove();
                map3dInstance = null;
            }

            mapboxgl.accessToken = CONFIG.mapbox.accessToken;

            map3dInstance = new mapboxgl.Map({
                container: 'map3d',
                style: 'mapbox://styles/mapbox/streets-v12',
                center: [center.lng, center.lat],
                zoom: Math.max(zoom, 14),
                pitch: 60,
                bearing: -20,
                antialias: true
            });

            map3dInstance.addControl(new mapboxgl.NavigationControl(), 'top-right');

            map3dInstance.on('style.load', () => {
                map3dInstance.addSource('mapbox-dem', {
                    type: 'raster-dem',
                    url: 'mapbox://mapbox.mapbox-terrain-dem-v1',
                    tileSize: 512,
                    maxzoom: 14
                });
                map3dInstance.setTerrain({ source: 'mapbox-dem', exaggeration: 1.5 });
                map3dInstance.setFog({
                    range: [0.8, 8],
                    color: '#d0e8f0',
                    'horizon-blend': 0.1,
                    'high-color': '#245bde',
                    'space-color': '#000000',
                    'star-intensity': 0.15
                });

                const layers = map3dInstance.getStyle().layers;
                const labelLayerId = layers.find(l => l.type === 'symbol' && l.layout['text-field'])?.id;

                map3dInstance.addLayer({
                    id: '3d-buildings',
                    source: 'composite',
                    'source-layer': 'building',
                    filter: ['==', 'extrude', 'true'],
                    type: 'fill-extrusion',
                    minzoom: 13,
                    paint: {
                        'fill-extrusion-color': '#aaa',
                        'fill-extrusion-height': ['interpolate', ['linear'], ['zoom'], 13, 0, 13.05, ['get', 'height']],
                        'fill-extrusion-base': ['interpolate', ['linear'], ['zoom'], 13, 0, 13.05, ['get', 'min_height']],
                        'fill-extrusion-opacity': 0.7
                    }
                }, labelLayerId);
            });
        }

        function close3DView() {
            document.getElementById('modal3D').style.display = 'none';
            document.body.style.overflow = 'hidden';
            if (map3dInstance) {
                map3dInstance.remove();
                map3dInstance = null;
            }
        }

        // GESTION DES ÉVÉNEMENTS
        function initializeEventListeners() {
            // Navigation et interface
            document.getElementById('toggleSidebar').addEventListener('click', toggleSidebar);
            document.getElementById('closeSidebar').addEventListener('click', closeSidebar);
            document.getElementById('sidebarOverlay').addEventListener('click', closeSidebar);
            document.getElementById('zoomHome').addEventListener('click', () => map.setView(CONFIG.map.center, CONFIG.map.zoom));
            document.getElementById('toggleSatellite').addEventListener('click', toggleSatelliteView);
            document.getElementById('toggle3D').addEventListener('click', open3DView);
            document.getElementById('close3D').addEventListener('click', close3DView);

            // Géolocalisation
            document.getElementById('locateUser').addEventListener('click', locateUser);
            
            // Outils de mesure
            document.getElementById('measureDistance').addEventListener('click', startDistanceMeasurement);
            document.getElementById('measureArea').addEventListener('click', startAreaMeasurement);
            document.getElementById('clearMeasurements').addEventListener('click', clearAllMeasurements);
            
            // Impression - Modal
            document.getElementById('printMap').addEventListener('click', openPrintModal);
            document.getElementById('closePrintModal').addEventListener('click', closePrintModal);
            document.getElementById('cancelPrint').addEventListener('click', closePrintModal);
            document.getElementById('proceedToPay').addEventListener('click', proceedToPayment);

            // Impression - Zone selection (manual mode)
            document.getElementById('selectPrintArea').addEventListener('click', togglePrintSelector);
            document.getElementById('useCurrentView').addEventListener('click', useCurrentMapView);
            document.getElementById('clearPrintArea').addEventListener('click', clearPrintAreaSelection);

            // Impression - Source mode switching
            document.getElementById('printSourceMode').addEventListener('change', function() {
                const mode = this.value;
                const adminGroup = document.getElementById('adminSelectGroup');
                const manualGroup = document.getElementById('manualSelectGroup');
                if (mode === 'admin') {
                    adminGroup.style.display = 'block';
                    manualGroup.style.display = 'none';
                } else {
                    adminGroup.style.display = 'none';
                    manualGroup.style.display = 'block';
                }
            });

            // Impression - Admin type change
            document.getElementById('adminType').addEventListener('change', function() {
                const adminType = this.value;
                if (adminType) {
                    loadAdminEntities(adminType);
                } else {
                    document.getElementById('adminEntity').style.display = 'none';
                }
            });

            // Impression - Admin entity selection
            document.getElementById('adminEntity').addEventListener('change', function() {
                const val = this.value;
                if (val !== '') {
                    selectAdminEntity(val);
                }
            });

            // Impression - Custom dimensions
            document.getElementById('customWidth').addEventListener('input', updateCustomPrice);
            document.getElementById('customHeight').addEventListener('input', updateCustomPrice);

            // Impression - Display options
            document.getElementById('mapTitle').addEventListener('input', updatePrintPreview);
            document.getElementById('outputFormat').addEventListener('change', updatePrintPreview);
            document.getElementById('showNorthArrow').addEventListener('change', updatePrintPreview);
            document.getElementById('showScale').addEventListener('change', updatePrintPreview);
            document.getElementById('showLegend').addEventListener('change', updatePrintPreview);
            document.getElementById('showCoordinates').addEventListener('change', updatePrintPreview);

            // Echelle utilisateur
            const userScaleEl = document.getElementById('userScale');
            if (userScaleEl) {
                userScaleEl.addEventListener('input', function() {
                    calculateAndDisplayScale();
                });
            }
            document.querySelectorAll('.scale-preset').forEach(preset => {
                preset.addEventListener('click', function() {
                    const scaleVal = this.dataset.scale;
                    const userScaleField = document.getElementById('userScale');
                    if (userScaleField) userScaleField.value = scaleVal;
                    calculateAndDisplayScale();
                });
            });

            // Impression - Format options
            document.querySelectorAll('.format-option').forEach(option => {
                option.addEventListener('click', function() {
                    const format = this.dataset.format;
                    const price = parseInt(this.dataset.price) || 0;
                    selectFormat(format, price);
                });
            });

            // Modal village
            document.getElementById('closeVillageModal').addEventListener('click', closeVillageModal);

            // Paiement
            document.getElementById('cancelPayment').addEventListener('click', cancelPayment);
            document.getElementById('confirmPayment').addEventListener('click', processPayment);

            // Selection des methodes de paiement
            document.querySelectorAll('.payment-method').forEach(method => {
                method.addEventListener('click', function() {
                    selectPaymentMethod(this.dataset.method);
                });
            });

            // Selectionner Mobile Money par defaut
            selectPaymentMethod('mobilemoney');

            document.querySelectorAll('.layer-toggle').forEach(toggle => {
                toggle.addEventListener('click', function() {
                    this.classList.toggle('active');
                    const layer = this.dataset.layer;
                    if (mapLayers[layer]) {
                        if (map.hasLayer(mapLayers[layer])) {
                            map.removeLayer(mapLayers[layer]);
                        } else {
                            map.addLayer(mapLayers[layer]);
                        }
                    }
                });
            });

            // Recherche intelligente
            document.getElementById('searchBtn').addEventListener('click', function() {
                const query = document.getElementById('searchInput').value.trim();
                if (query.length >= 2) {
                    performIntelligentSearch(query);
                }
            });

            // Raccourcis clavier
            document.addEventListener('keydown', function(e) {
                if (e.ctrlKey && e.key === 'd') {
                    e.preventDefault();
                    startDistanceMeasurement();
                } else if (e.ctrlKey && e.key === 's') {
                    e.preventDefault();
                    startAreaMeasurement();
                } else if (e.ctrlKey && e.key === 'p') {
                    e.preventDefault();
                    openPrintModal();
                } else if (e.ctrlKey && e.key === 'l') {
                    e.preventDefault();
                    locateUser();
                } else if (e.key === 'Escape') {
                    if (document.getElementById('villageModal').classList.contains('active')) {
                        closeVillageModal();
                    } else if (document.getElementById('printModal').classList.contains('active')) {
                        closePrintModal();
                    } else if (document.getElementById('paymentModal').classList.contains('active')) {
                        cancelPayment();
                    } else if (isLocating) {
                        stopLocationTracking();
                    }
                }
            });

            map.on('zoomend moveend', function() {
                // Réappliquer la hiérarchie après chaque interaction
                setTimeout(() => applyLayerHierarchy(), 100);
            });


        }

        // ADMINISTRATION
        window.checkAdminAccess = function() {
            window.location.href = 'login.html';
        };

        // ================================================================
        // MODE ÉDITION ADMIN - Villages ponctuels
        // ================================================================
        let vpEditMode = false;
        let vpAdminUser = null;
        let vpActiveTool = null; // 'move' | 'edit' | 'add'

        async function checkAdminSession() {
            if (!supabase) return;
            try {
                const { data: { session } } = await supabase.auth.getSession();
                if (!session) return;
                const { data: profile, error } = await supabase
                    .from('admin_profiles')
                    .select('id, is_active')
                    .eq('id', session.user.id)
                    .eq('is_active', true)
                    .single();
                if (!error && profile) {
                    vpAdminUser = session.user;
                    document.getElementById('vpAdminBtn').classList.add('visible');
                    refreshVpPopups();
                }
            } catch (e) { }
        }

        function setVpTool(tool) {
            if (vpActiveTool === tool) { vpActiveTool = null; } else { vpActiveTool = tool; }
            document.getElementById('vpToolAdd').classList.toggle('active', vpActiveTool === 'add');
            const mapEl = document.getElementById('map');
            mapEl.classList.remove('vp-edit-mode-move', 'vp-edit-mode-add');
            if (vpActiveTool === 'add') mapEl.classList.add('vp-edit-mode-add');
        }

        let movingVpId = null;

        function applyVpEditBehavior() {
        }

        function toggleVpEditMode() {
            if (!vpAdminUser) { showNotification(t('notif.admin_only'), 'error'); return; }
            vpEditMode = !vpEditMode;
            vpActiveTool = null;
            const btn = document.getElementById('vpAdminBtn');
            btn.classList.toggle('active', vpEditMode);
            btn.innerHTML = vpEditMode
                ? '<i class="fas fa-check"></i> Fin édition'
                : '<i class="fas fa-map-pin"></i> Mode édition';
            document.getElementById('map').classList.toggle('vp-edit-mode', vpEditMode);
            document.getElementById('map').classList.remove('vp-edit-mode-move', 'vp-edit-mode-add');
            document.getElementById('vpToolbar').classList.toggle('visible', vpEditMode);
            document.getElementById('vpToolAdd').classList.remove('active');

            applyVpEditBehavior();
            refreshVpPopups();
        }

        function refreshVpPopups() {
            if (!mapLayers.villagesPonctuels) return;
            mapLayers.villagesPonctuels.eachLayer(marker => {
                if (!marker.vpData) return;
                const vp = marker.vpData;
                const parentName = vp[cc().vpParentCol] || vp.arrondissement_name || vp.district_name || t('village.not_determined');
                marker.setPopupContent(createVillagePonctuelPopup(vp, parentName));
            });
        }


        function onMapClickAddVp(e) {
            if (!vpEditMode || vpActiveTool !== 'add') return;
            const parentCol = cc().vpParentCol;
            const newVp = {
                name: '',
                [parentCol]: findParentAdminForPoint(e.latlng.lat, e.latlng.lng),
                population: null,
                geom: { type: 'Point', coordinates: [e.latlng.lng, e.latlng.lat] }
            };
            openVpEditForm(newVp, null, true);
        }

        function openVpEditForm(vp, marker, isNew) {
            const config = cc();
            const levels = config.adminLevels;
            const parentLevel = levels[levels.length - 1];
            const parentLabel = parentLevel ? t(parentLevel.labelKey) : t('popup.arrondissement');
            const parentCol = config.vpParentCol;
            const parentCache = parentLevel ? (mapDataCache[parentLevel.key] || []) : [];
            const parentOptions = parentCache
                .map(a => a[parentLevel.nameCol])
                .filter(Boolean)
                .sort()
                .map(n => `<option value="${n}" ${n === (vp[parentCol] || vp.arrondissement_name || vp.district_name) ? 'selected' : ''}>${n}</option>`)
                .join('');

            let lat = '', lng = '';
            const geom = typeof vp.geom === 'string' ? JSON.parse(vp.geom) : vp.geom;
            if (geom) {
                if (geom.type === 'MultiPoint') { lng = geom.coordinates[0][0]; lat = geom.coordinates[0][1]; }
                else if (geom.type === 'Point') { lng = geom.coordinates[0]; lat = geom.coordinates[1]; }
            }

            const deleteBtn = isNew ? '' : `<button type="button" class="vp-btn-delete" onclick="deleteVpFromForm()">${t('vp.delete')}</button>`;

            const modal = document.createElement('div');
            modal.className = 'vp-edit-modal';
            modal.id = 'vpEditModal';
            modal.innerHTML = `
                <div class="vp-edit-form">
                    <h3>${isNew ? t('vp.add_title') : t('vp.edit_mode')}</h3>
                    <label>${t('admin.col_name')}</label>
                    <input type="text" id="vpEditName" value="${vp.name || ''}" placeholder="${t('popup.no_name')}">
                    <label>${parentLabel}</label>
                    <select id="vpEditArr"><option value="">—</option>${parentOptions}</select>
                    <label>${t('popup.population')}</label>
                    <input type="number" id="vpEditPop" value="${vp.population || ''}" min="0" placeholder="0">
                    <div class="vp-coords-row">
                        <div><label>Latitude</label><input type="number" id="vpEditLat" value="${lat}" step="0.000001" placeholder="5.0"></div>
                        <div><label>Longitude</label><input type="number" id="vpEditLng" value="${lng}" step="0.000001" placeholder="12.0"></div>
                    </div>
                    <div class="vp-btn-row">
                        <button type="button" class="vp-btn-save" onclick="saveVpFromForm()">${t('vp.add_tool')}</button>
                        <button type="button" class="vp-btn-cancel" onclick="closeVpEditForm()">${t('vp.cancel')}</button>
                        ${deleteBtn}
                    </div>
                </div>
            `;
            document.body.appendChild(modal);
            window._vpEditCtx = { vp, marker, isNew };
            document.getElementById('vpEditName').focus();
        }

        window.closeVpEditForm = function() {
            const m = document.getElementById('vpEditModal');
            if (m) m.remove();
        };

        window.saveVpFromForm = async function() {
            if (!vpAdminUser) { showNotification(t('notif.admin_only'), 'error'); return; }
            const ctx = window._vpEditCtx;
            if (!ctx) return;
            const name = document.getElementById('vpEditName').value.trim();
            const arr = document.getElementById('vpEditArr').value;
            const pop = parseInt(document.getElementById('vpEditPop').value) || null;
            const newLat = parseFloat(document.getElementById('vpEditLat').value);
            const newLng = parseFloat(document.getElementById('vpEditLng').value);

            if (!name) { showNotification(t('notif.name_required'), 'warning'); return; }
            if (isNaN(newLat) || isNaN(newLng)) { showNotification(t('notif.invalid_coords'), 'warning'); return; }

            const newGeom = { type: 'Point', coordinates: [newLng, newLat] };
            const parentCol = cc().vpParentCol;
            const data = {
                name,
                [parentCol]: arr || null,
                population: pop,
                geom: newGeom
            };

            try {
                if (ctx.isNew) {
                    const { data: inserted, error } = await supabase
                        .from(cc().vpTable)
                        .insert(data)
                        .select()
                        .single();
                    if (error) throw error;
                    addVpMarkerToMap(inserted);
                    if (vpSearchCache) {
                        vpSearchCache.push({ ...inserted, _nameNorm: removeAccents(inserted.name.toLowerCase()) });
                    }

                    showNotification(t('notif.village_added'), 'success', 1500);
                } else {
                    const { error } = await supabase
                        .from(cc().vpTable)
                        .update(data)
                        .eq('id', ctx.vp.id);
                    if (error) throw error;
                    Object.assign(ctx.vp, data);
                    if (ctx.marker) {
                        ctx.marker.setLatLng([newLat, newLng]);
                        ctx.marker.vpData = ctx.vp;
                        if (ctx.marker.getTooltip()) ctx.marker.unbindTooltip();
                        const zoom = map.getZoom();
                        if (zoom >= 12 && name) {
                            ctx.marker.bindTooltip(name, { permanent: true, direction: 'right', offset: [6, 0], className: 'vp-label' });
                        }
                        const parentName = data[cc().vpParentCol] || t('village.not_determined');
                        ctx.marker.setPopupContent(createVillagePonctuelPopup(ctx.vp, parentName));
                    }
                    if (vpSearchCache) {
                        const idx = vpSearchCache.findIndex(v => v.id === ctx.vp.id);
                        if (idx >= 0) Object.assign(vpSearchCache[idx], data, { _nameNorm: removeAccents(name.toLowerCase()) });
                    }

                    showNotification(t('notif.village_updated'), 'success', 1500);
                }
                closeVpEditForm();
            } catch (e) {
                console.error(e);
                showNotification(t('notif.error_prefix', {message: e.message}), 'error');
            }
        };

        window.deleteVpFromForm = async function() {
            if (!vpAdminUser) { showNotification(t('notif.admin_only'), 'error'); return; }
            const ctx = window._vpEditCtx;
            if (!ctx || ctx.isNew) return;
            if (!confirm('Supprimer ce village ?')) return;
            try {
                const { error } = await supabase
                    .from(cc().vpTable)
                    .delete()
                    .eq('id', ctx.vp.id);
                if (error) throw error;
                if (ctx.marker && mapLayers.villagesPonctuels) {
                    mapLayers.villagesPonctuels.removeLayer(ctx.marker);
                }
                if (vpSearchCache) {
                    vpSearchCache = vpSearchCache.filter(v => v.id !== ctx.vp.id);
                }
                showNotification(t('notif.village_deleted'), 'success', 1500);
                closeVpEditForm();
            } catch (e) {
                showNotification(t('notif.delete_error'), 'error');
            }
        };

        window.vpPopupEdit = function(vpId) {
            map.closePopup();
            if (!mapLayers.villagesPonctuels) return;
            mapLayers.villagesPonctuels.eachLayer(marker => {
                if (marker.vpData && marker.vpData.id === vpId) {
                    openVpEditForm(marker.vpData, marker);
                }
            });
        };

        window.vpPopupMove = function(vpId) {
            if (!vpAdminUser) return;
            map.closePopup();
            movingVpId = vpId;
            const vp = findVpById(vpId);
            const name = vp ? vp.name : 'village';
            document.getElementById('vpMoveBar').style.display = 'flex';
            document.getElementById('vpMoveText').innerHTML = '<i class="fas fa-arrows-alt"></i> Cliquez la nouvelle position pour <strong>' + name + '</strong>';
            map.getContainer().style.cursor = 'crosshair';
        };

        window.cancelVpMove = function() {
            movingVpId = null;
            document.getElementById('vpMoveBar').style.display = 'none';
            map.getContainer().style.cursor = '';
        };

        function findVpById(vpId) {
            let found = null;
            if (mapLayers.villagesPonctuels) {
                mapLayers.villagesPonctuels.eachLayer(m => {
                    if (m.vpData && m.vpData.id === vpId) found = m.vpData;
                });
            }
            return found;
        }

        function findVpMarkerById(vpId) {
            let found = null;
            if (mapLayers.villagesPonctuels) {
                mapLayers.villagesPonctuels.eachLayer(m => {
                    if (m.vpData && m.vpData.id === vpId) found = m;
                });
            }
            return found;
        }

        window.vpPopupDelete = function(vpId) {
            if (!vpAdminUser) return;
            if (!confirm('Supprimer ce village ?')) return;
            supabase.from(cc().vpTable).delete().eq('id', vpId).then(({ error }) => {
                if (error) { showNotification(t('notif.delete_error'), 'error'); return; }
                if (mapLayers.villagesPonctuels) {
                    mapLayers.villagesPonctuels.eachLayer(marker => {
                        if (marker.vpData && marker.vpData.id === vpId) {
                            mapLayers.villagesPonctuels.removeLayer(marker);
                        }
                    });
                }
                if (vpSearchCache) vpSearchCache = vpSearchCache.filter(v => v.id !== vpId);
                map.closePopup();
                showNotification(t('notif.village_deleted'), 'success', 1500);
            });
        };

        function addVpMarkerToMap(vp) {
            if (!mapLayers.villagesPonctuels) return;
            const geom = typeof vp.geom === 'string' ? JSON.parse(vp.geom) : vp.geom;
            if (!geom) return;
            const lng = geom.type === 'MultiPoint' ? geom.coordinates[0][0] : geom.coordinates[0];
            const lat = geom.type === 'MultiPoint' ? geom.coordinates[0][1] : geom.coordinates[1];

            const marker = L.circleMarker([lat, lng], {
                radius: 1.3,
                fillColor: '#000000',
                color: '#000000',
                weight: 1,
                opacity: 1,
                fillOpacity: 1,
                pane: 'villagesPonctuelsPane'
            }).addTo(mapLayers.villagesPonctuels);

            marker.vpData = vp;
            const parentName = vp[cc().vpParentCol] || vp.arrondissement_name || vp.district_name || findParentAdminForPoint(lat, lng);
            marker.bindPopup(createVillagePonctuelPopup(vp, parentName), {
                maxWidth: window.innerWidth < 480 ? (window.innerWidth - 60) : 280,
                minWidth: 180,
                className: 'village-popup'
            });


            const zoom = map.getZoom();
            if (zoom >= 12 && vp.name) {
                marker.bindTooltip(vp.name, { permanent: true, direction: 'right', offset: [6, 0], className: 'vp-label' });
            }
        }

        function trackPageVisit() {
            if (!supabase) return;
            try {
                const sessionId = sessionStorage.getItem('mv_session');
                if (sessionId) return;
                const newSession = crypto.randomUUID ? crypto.randomUUID() : Date.now().toString(36);
                sessionStorage.setItem('mv_session', newSession);
                supabase.from('user_sessions').insert({
                    session_token: newSession,
                    user_agent: navigator.userAgent,
                    expires_at: new Date(Date.now() + 24*60*60*1000).toISOString(),
                    is_active: true
                }).then(({ error }) => {
                    if (error) console.error('Erreur tracking visite:', error);
                });
            } catch (e) {
                console.error('Erreur tracking:', e);
            }
        }

        // FONCTIONS D'INITIALISATION (à placer AVANT DOMContentLoaded)
            function initializeSupabase() {
                try {
                    supabase = window.supabase.createClient(CONFIG.supabase.url, CONFIG.supabase.anonKey);
                    console.log('✅ Supabase initialisé avec variables d\'environnement');
                } catch (error) {
                    console.error('❌ Erreur Supabase:', error);
                    showNotification(t('notif.offline_demo'), 'warning');
                }
            }

            function initializeMap() {
                console.log('🗺️ Initialisation de la carte avec panes personnalisés');
                
                map = L.map('map', { 
                    center: CONFIG.map.center, 
                    zoom: CONFIG.map.zoom, 
                    zoomControl: false,
                    preferCanvas: true,
                    renderer: L.canvas({ padding: 0.5 }),
                });
                
                L.control.zoom({ position: 'bottomright' }).addTo(map);

                baseLayers.standard = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                    maxZoom: 19,
                    updateWhenIdle: true,
                    updateWhenZooming: false
                });

                baseLayers.satellite = L.tileLayer('https://mt1.google.com/vt/lyrs=s&x={x}&y={y}&z={z}', {
                    attribution: '© Google',
                    maxZoom: 22,
                    updateWhenIdle: true,
                    updateWhenZooming: false
                });

                baseLayers.standard.addTo(map);
                
                // ✅ AJOUTER CETTE LIGNE
                createCustomPanes();
                
                map.on('zoomend moveend', loadLayersByZoom);
                
                console.log('✅ Carte initialisée avec panes personnalisés');
            }

            function initializeNativeMeasurementTools() {
                measurementLayer = new L.FeatureGroup();
                map.addLayer(measurementLayer);
            }


        // DISCLAIMER
        function showDisclaimer() {
            if (localStorage.getItem('monvillage_disclaimer_accepted')) return;
            const modal = document.getElementById('disclaimerModal');
            modal.style.display = 'flex';
            document.getElementById('disclaimerAccept').addEventListener('click', function() {
                localStorage.setItem('monvillage_disclaimer_accepted', '1');
                modal.style.display = 'none';
            });
        }

        // GEO-PRICING: refresh all displayed prices when location is detected
        function refreshPriceDisplay() {
            if (!isOutsideAfrica()) return;
            const currency = cc().currency;
            document.querySelectorAll('.format-option').forEach(opt => {
                const basePrice = parseInt(opt.dataset.price) || 0;
                if (basePrice > 0) {
                    const effective = getEffectivePrice(basePrice);
                    const priceEl = opt.querySelector('.format-price');
                    if (priceEl) priceEl.textContent = effective.toLocaleString() + ' ' + currency;
                }
            });
            if (printConfig.price > 0) {
                const sel = document.querySelector('.format-option.selected');
                if (sel) {
                    const bp = parseInt(sel.dataset.price) || 0;
                    if (bp > 0) printConfig.price = getEffectivePrice(bp);
                }
                updateSummaryFields();
            }
        }

        // SUBSCRIPTION PROMPT for users outside Africa (after 30s)
        let subscriptionPromptShown = false;
        function scheduleSubscriptionPrompt() {
            if (subscriptionPromptShown) return;
            setTimeout(function() {
                if (subscriptionPromptShown || !isOutsideAfrica()) return;
                subscriptionPromptShown = true;
                showSubscriptionModal();
            }, 30000);
        }

        function showSubscriptionModal() {
            let modal = document.getElementById('subscriptionModal');
            if (!modal) {
                modal = document.createElement('div');
                modal.id = 'subscriptionModal';
                modal.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.85);z-index:10003;display:flex;align-items:center;justify-content:center;';
                modal.innerHTML = `
                    <div style="background:white;border-radius:15px;padding:30px;max-width:480px;width:90%;text-align:center;font-family:inherit;">
                        <div style="font-size:40px;margin-bottom:15px;">🌍</div>
                        <h3 id="subModalTitle" style="font-size:20px;font-weight:bold;color:#2c5530;margin-bottom:12px;"></h3>
                        <p id="subModalText" style="color:#555;margin-bottom:8px;line-height:1.5;"></p>
                        <div style="background:#f0f8f1;border-radius:10px;padding:15px;margin:15px 0;">
                            <div style="font-size:28px;font-weight:bold;color:#4a7c59;">10 $ <span style="font-size:14px;font-weight:normal;">USD / <span id="subModalMonth"></span></span></div>
                            <p id="subModalInclude" style="font-size:13px;color:#666;margin-top:6px;"></p>
                        </div>
                        <p id="subModalAlt" style="font-size:13px;color:#888;margin-bottom:18px;"></p>
                        <div style="display:flex;gap:10px;justify-content:center;flex-wrap:wrap;">
                            <button id="subModalClose" style="padding:10px 24px;border:1px solid #ddd;border-radius:8px;background:white;cursor:pointer;font-size:14px;min-width:100px;"></button>
                            <button id="subModalContact" style="padding:10px 24px;border:none;border-radius:8px;background:#4a7c59;color:white;cursor:pointer;font-size:14px;font-weight:bold;min-width:100px;"></button>
                        </div>
                    </div>`;
                document.body.appendChild(modal);
                document.getElementById('subModalClose').addEventListener('click', function() {
                    modal.style.display = 'none';
                });
                document.getElementById('subModalContact').addEventListener('click', function() {
                    window.open('mailto:intello.corporation@gmail.com?subject=MonVillage%20Subscription', '_blank');
                    modal.style.display = 'none';
                });
            }
            document.getElementById('subModalTitle').textContent = t('subscription.title');
            document.getElementById('subModalText').textContent = t('subscription.text');
            document.getElementById('subModalMonth').textContent = t('subscription.month');
            document.getElementById('subModalInclude').textContent = t('subscription.includes');
            document.getElementById('subModalAlt').textContent = t('subscription.alt');
            document.getElementById('subModalClose').textContent = t('subscription.close');
            document.getElementById('subModalContact').textContent = t('subscription.subscribe');
            modal.style.display = 'flex';
        }

        // COUNTRY/LANG SWITCHING
        function updatePriceCurrency() {
            const currency = cc().currency;
            document.querySelectorAll('.format-price').forEach(el => {
                el.textContent = el.textContent.replace(/XAF|UGX/, currency);
            });
            document.querySelectorAll('.total-price, #paymentAmount').forEach(el => {
                el.textContent = el.textContent.replace(/XAF|UGX/, currency);
            });
        }

        function switchCountry(code) {
            if (code === currentCountry) return;
            setCountry(code);
            document.body.setAttribute('data-country', code);

            // Update flag highlights
            document.getElementById('flagCM').className = 'country-flag ' + (code === 'cm' ? 'active' : 'inactive');
            document.getElementById('flagUG').className = 'country-flag ' + (code === 'ug' ? 'active' : 'inactive');

            // Show/hide cm-only / ug-only elements
            document.querySelectorAll('.cm-only').forEach(el => el.style.display = code === 'cm' ? '' : 'none');
            document.querySelectorAll('.ug-only').forEach(el => el.style.display = code === 'ug' ? '' : 'none');

            // Set default language for new country if user hasn't explicitly chosen one
            if (!localStorage.getItem('monvillage_lang_explicit')) {
                setLang(cc().defaultLang);
                updateLangUI();
            }

            // Update search placeholder (country-specific)
            const searchInput = document.getElementById('searchInput');
            if (searchInput) searchInput.placeholder = tc('search.placeholder');

            // Update phone placeholder
            const phoneInput = document.getElementById('customer-phone');
            if (phoneInput) phoneInput.placeholder = tc('payment.phone_placeholder');

            translatePage();
            translateCountrySpecific();
            updatePriceCurrency();

            // Clear and reload map data
            clearAllMapLayers();
            Object.keys(mapDataCache).forEach(k => mapDataCache[k] = []);
            vpAllData = null;
            vpAllDataPromise = null;
            vpSearchCache = null;
            if (map) {
                map.setView(cc().map.center, cc().map.zoom);
                loadInitialData();
            }
        }

        function clearAllMapLayers() {
            Object.keys(mapLayers).forEach(key => {
                if (mapLayers[key] && map) {
                    map.removeLayer(mapLayers[key]);
                    mapLayers[key] = null;
                }
            });
        }

        function updateLangUI() {
            const lang = getLang();
            document.getElementById('langFR').className = 'lang-option ' + (lang === 'fr' ? 'active' : 'inactive');
            document.getElementById('langEN').className = 'lang-option ' + (lang === 'en' ? 'active' : 'inactive');
        }

        function initCountryLangSelectors() {
            document.getElementById('flagCM').addEventListener('click', () => switchCountry('cm'));
            document.getElementById('flagUG').addEventListener('click', () => switchCountry('ug'));
            document.getElementById('langFR').addEventListener('click', () => {
                localStorage.setItem('monvillage_lang_explicit', '1');
                setLang('fr');
                updateLangUI();
            });
            document.getElementById('langEN').addEventListener('click', () => {
                localStorage.setItem('monvillage_lang_explicit', '1');
                setLang('en');
                updateLangUI();
            });

            // Set initial state
            document.getElementById('flagCM').className = 'country-flag ' + (currentCountry === 'cm' ? 'active' : 'inactive');
            document.getElementById('flagUG').className = 'country-flag ' + (currentCountry === 'ug' ? 'active' : 'inactive');
            updateLangUI();
            document.querySelectorAll('.cm-only').forEach(el => el.style.display = currentCountry === 'cm' ? '' : 'none');
            document.querySelectorAll('.ug-only').forEach(el => el.style.display = currentCountry === 'ug' ? '' : 'none');
        }

        // INITIALISATION PRINCIPALE
        document.addEventListener('DOMContentLoaded', function() {
            try {
                console.log('🚀 Initialisation MonVillage multi-pays');

                initCountryLangSelectors();
                translatePage();
                translateCountrySpecific();

                showDisclaimer();
                initializeSupabase();
                initializeMap();
                initializeNativeMeasurementTools();
                initializeEventListeners();
                initializeIntelligentSearch();
                loadInitialData();
                trackPageVisit();
                checkAdminSession();
                detectUserLocation();

                document.getElementById('vpAdminBtn').addEventListener('click', toggleVpEditMode);
                document.getElementById('vpToolAdd').addEventListener('click', () => setVpTool('add'));
                map.on('click', async function(e) {
                    if (movingVpId) {
                        const vpId = movingVpId;
                        const newLatLng = e.latlng;
                        cancelVpMove();
                        if (!confirm(t('vp.move_click') + '\nLat: ' + newLatLng.lat.toFixed(6) + '\nLng: ' + newLatLng.lng.toFixed(6) + ' ?')) return;
                        const geom = { type: 'Point', coordinates: [newLatLng.lng, newLatLng.lat] };
                        const vpTableName = cc().vpTable;
                        const { error } = await supabase.from(vpTableName).update({ geom }).eq('id', vpId);
                        if (error) { showNotification(t('notif.load_error'), 'error'); return; }
                        const marker = findVpMarkerById(vpId);
                        if (marker) { marker.setLatLng(newLatLng); marker.vpData.geom = geom; }
                        showNotification(t('notif.village_updated'), 'success', 2000);
                        return;
                    }
                    if (vpEditMode && vpActiveTool === 'add') onMapClickAddVp(e);
                });

                showNotification(t('notif.app_loaded'), 'success');

            } catch (error) {
                console.error('Erreur lors de l\'initialisation:', error);
                showNotification(t('notif.load_error'), 'error');
            }
        });




        // (print event listeners moved to initializeEventListeners)




        window.addEventListener('resize', function() {
            const sidebar = document.getElementById('sidebar');
            const overlay = document.getElementById('sidebarOverlay');
            
            if (window.innerWidth > 768) {
                sidebar.classList.remove('open');
                overlay.classList.remove('active');
                document.body.style.overflow = '';
            }
            
            if (map) {
                setTimeout(() => map.invalidateSize(), 100);
            }
            
            if (previewMap) {
                setTimeout(() => previewMap.invalidateSize(), 100);
            }
        });

        // Gestion des erreurs globales
        window.addEventListener('error', function(e) {
            console.error('Erreur globale:', e.error);
            showNotification(t('notif.unexpected_error'), 'error');
        });

        window.addEventListener('unhandledrejection', function(e) {
            console.error('Promise non gérée:', e.reason);
            showNotification(t('notif.connection_error'), 'warning');
        });



        /* ----------  z-index helpers  ---------- */
               function bringToFront(layerGroup) {
    if (!layerGroup) return;
    
    layerGroup.eachLayer(layer => {
        // Ramener au premier plan
        if (layer.bringToFront) {
            layer.bringToFront();
        }
        
        // Appliquer un z-index très élevé
        if (layer.setZIndexOffset) {
            layer.setZIndexOffset(1000);
        }
        
        // Forcer l'interactivité
        if (layer.setStyle) {
            layer.setStyle({
                interactive: true
            });
        }
        
        // Si c'est un groupe, traiter récursivement
        if (layer.eachLayer) {
            bringToFront(layer);
        }
    });
}


                function sendToBack(layerGroup) {
                    if (!layerGroup) return;
                    layerGroup.eachLayer(layer => {
                        if (layer.bringToBack) {
                            layer.bringToBack();
                        }
                        if (layer.setZIndexOffset) {
                            // Remettre à 0
                            layer.setZIndexOffset(0);
                        }
                    });
                }

    

    